(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bag-size-advisor-script"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  const esc=v=>String(v??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const norm=v=>String(v??'').normalize('NFKC').replace(/\u00a0/g,' ').trim();
  const clamp=(n,a,b)=>Math.max(a,Math.min(b,n));
  const fmt=n=>String(Math.round(n*100)/100);
  const axes=['width','height','depth'];
  const excluded=/持ち手|ハンドル|ストラップ|ショルダー|肩紐|ポケット|開口|底幅|上部|下部|内寸|handle|strap|shoulder|pocket|opening|bottom|internal|inside|\b(?:manic[oi]|manigl(?:ia|ie)|tracoll[ae]|spallacci[oi]|tasc(?:a|he)|apertur[ae]|intern[oaie]|superiore|inferiore)\b|\b(?:della|alla)\s+base\b|\b(?:handvat(?:ten)?|hengsels?|(?:schouder|draag)(?:band|riem)(?:en)?|binnen(?:maat|maten|zijde)|vak(?:je|ken|jes)?|bodem|bovenkant|onderkant)\b/i;
  function axis(label){
    let s=norm(label).toLowerCase().replace(/[\[\](（)）\s:：]/g,'').replace(/cm|mm|センチ|ミリ|インチ|inches|inch/g,'');
    if(excluded.test(s))return null;
    if(/^(w|横幅|横|幅|width|breite|largeur|ancho|larghezza|breedte|寬度|宽度|寬|宽|가로|너비|lebar|ความกว้าง)$/.test(s))return 'width';
    if(/^(h|高さ|高|縦|縦幅|height|höhe|hauteur|alto|altura|altezza|hoogte|高度|길이|세로|높이|tinggi|ความสูง)$/.test(s))return 'height';
    if(/^(d|奥行き|奥行|厚さ|厚み|マチ|depth|thickness|tiefe|profondeur|fondo|profundidad|profondità|profondita|spessore|diepte|dikte|深度|厚度|폭|깊이|kedalaman|ความลึก)$/.test(s))return 'depth';
    return null;
  }
  function unit(text){
    const s=norm(text).toLowerCase();
    if(/mm|ミリ|毫米|밀리/.test(s))return .1;
    if(/inch|インチ|英寸|인치|[″"]/.test(s))return 2.54;
    return 1;
  }
  function value(text,multiplier=1){
    const s=norm(text).toLowerCase().replace(/^(約|about|approx\.?|ca\.?)\s*/,'').replace(/[\[\]()\s]/g,'');
    const m=s.match(/^(\d+(?:\.\d+|,\d{1,2})?)(cm|mm|センチ|ミリ|inches|inch|インチ|″|")?$/);
    if(!m)return null;
    const n=Number(m[1].replace(',','.'))*(m[2]?unit(m[2]):multiplier);
    return Number.isFinite(n)&&n>=.05&&n<=150?Math.round(n*10000)/10000:null;
  }
  function parseLines(text){
    const claims={width:[],height:[],depth:[]},rejected=new Set();
    const add=(k,n)=>{if(!k)return;if(n===null)rejected.add(k);else claims[k].push(n);};
    for(const raw of norm(text).split(/[\n;；]/)){
      const line=raw.trim();if(!line||excluded.test(line))continue;
      const colon=line.search(/[:：]/),left=colon>=0?line.slice(0,colon):'',right=colon>=0?line.slice(colon+1):'';
      const heads=left.split(/[×xX*\/]/).map(axis);
      if(heads.length>=2&&heads.every(Boolean)){
        const vals=right.split(/[×xX*]/),mul=unit(line);
        if(heads.length===vals.length&&new Set(heads).size===heads.length)heads.forEach((k,i)=>add(k,value(vals[i],mul)));
        else heads.forEach(k=>rejected.add(k));
        continue;
      }
      const labels='横幅|縦幅|奥行き|奥行|高さ|厚さ|厚み|マチ|横|縦|幅|高|width|height|depth|thickness|breite|höhe|tiefe|largeur|hauteur|profondeur|ancho|alto|altura|fondo|profundidad|larghezza|altezza|profondità|profondita|spessore|breedte|hoogte|diepte|dikte|寬度|宽度|高度|深度|厚度|가로|세로|높이|너비|깊이|lebar|tinggi|kedalaman|ความกว้าง|ความสูง|ความลึก|w|h|d';
      const re=new RegExp('(?<![a-zA-Z])('+labels+')(?:\\s*[\\[(](cm|mm|inch)[\\])])?\\s*[:：=]?\\s*(?:約|about|approx\\.?|ca\\.?)?\\s*(\\d+(?:[.,]\\d+)?(?:\\s*[~〜～–—-]\\s*\\d+(?:[.,]\\d+)?)?)\\s*(cm|mm|inch|インチ|センチ|ミリ)?','gi');
      for(const m of line.matchAll(re)){
        const tail=line.slice(m.index+m[0].length),unknownUnit=/^\s*(?:m\b|meters?\b|metres?\b|kg\b|g\b|ft\b|feet\b|ml\b)/i.test(tail);
        add(axis(m[1]),unknownUnit?null:value(m[3]+(m[4]??''),m[2]?unit(m[2]):unit(line)));
      }
    }
    const result={};
    for(const k of axes){const numbers=claims[k];if(!rejected.has(k)&&numbers.length&&numbers.every(n=>Math.abs(n-numbers[0])<.01))result[k]=numbers[0];else if(numbers.length)rejected.add(k);}
    return {dims:result,conflict:rejected.size>0};
  }
  function normalize(config,text,tables=[]){
    const identity=norm(config.type)+' '+norm(config.title);
    const isBag=/\b(?:bags?|handbags?|backpacks?|rucksacks?|totes?|bors[ae]|zain[oi]|zainett[oi]|marsupio?|borson[ei]|pochette|(?:hand|schouder|crossbody|heup|sport|reis|rug|buidel)?tas(?:sen)?|rugzak(?:ken)?|shoppers?)\b|バッグ|かばん|鞄|リュック|トートバック|ショルダーバック|バックパック/i.test(identity);
    if(!isBag)return {supported:false,rows:[]};
    const options=(config.options??[]).map(o=>typeof o==='string'?o:o.name),sizeIndex=options.findIndex(o=>/^(size|taglia|taglie|maat|maten|サイズ|尺寸|尺码|사이즈)$/i.test(norm(o)));
    const sizes=sizeIndex<0?[]:[...new Set((config.variants??[]).map(v=>v.options?.[sizeIndex]??v['option'+(sizeIndex+1)]).filter(Boolean))];
    const baseLines=[text],namedRows=[];let ambiguous=false;
    for(const rows of tables){
      const headIndex=rows.findIndex(row=>row.filter(c=>axis(c)).length>=2);
      if(headIndex>=0){
        const header=rows[headIndex],cols=header.map(axis),labelIndex=header.findIndex(c=>/^(size|taglia|taglie|maat|maten|サイズ|尺寸|尺码|사이즈)$/i.test(norm(c))),body=rows.slice(headIndex+1);
        if(body.length>1&&labelIndex<0){ambiguous=true;continue;}
        for(const row of body){
          if(row.length!==header.length){ambiguous=true;continue;}
          const cells=row.map((v,i)=>cols[i]?header[i]+': '+v:'').filter(Boolean).join('\n');
          if(labelIndex>=0&&sizes.length>1){const label=sizes.find(s=>norm(s).toLowerCase()===norm(row[labelIndex]).toLowerCase());if(label)namedRows.push({label,...parseLines(cells)});}
          else baseLines.push(cells);
        }
      }else{
        for(const row of rows)if(row.length===2&&axis(row[0]))baseLines.push(row[0]+': '+row[1]);
        for(const row of rows)if(row.length===2&&!axis(row[0])&&!excluded.test(row[0]))baseLines.push(row[1]);
      }
    }
    const base=parseLines(baseLines.join('\n'));
    const candidates=namedRows.length?namedRows.map(row=>({label:row.label,dims:{...base.dims,...row.dims},conflict:row.conflict})):sizes.length>1?[]:[{label:sizes[0]??'',...base}];
    const rows=candidates.filter(row=>!row.conflict&&row.dims.width&&row.dims.height).map(row=>({label:row.label,...row.dims}));
    const duplicate=new Set(rows.map(r=>r.label)).size!==rows.length;
    return {supported:!ambiguous&&!duplicate&&rows.length>0,rows:ambiguous||duplicate?[]:rows,sizeIndex};
  }
  const catalog=Object.freeze([
    {id:'bottle500',width:6.5,height:21.5,depth:6.5,shape:'bottle',basis:'example'},
    {id:'phone',width:7.16,height:14.76,depth:.78,shape:'phone',basis:'manufacturer',source:'https://support.apple.com/en-us/121029'},
    {id:'long_wallet',width:19.5,height:9.5,depth:2.5,shape:'wallet',basis:'example'},
    {id:'fold_wallet',width:11,height:9.5,depth:2.5,shape:'wallet',basis:'example'},
    {id:'a4',width:21,height:29.7,depth:.01,shape:'paper',basis:'paper'},
    {id:'b5',width:18.2,height:25.7,depth:.01,shape:'paper',basis:'paper'},
    {id:'tablet',width:13.48,height:19.54,depth:.63,shape:'tablet',basis:'manufacturer',source:'https://support.apple.com/ja-jp/121456'},
    {id:'laptop',width:30.41,height:21.5,depth:1.13,shape:'laptop',basis:'manufacturer',source:'https://support.apple.com/en-au/122209'},
    {id:'book',width:12.8,height:18.2,depth:2,shape:'book',basis:'example'},
    {id:'umbrella',width:5,height:24,depth:5,shape:'umbrella',basis:'example'},
    {id:'glasses',width:16,height:6.5,depth:4,shape:'glasses',basis:'example'},
    {id:'keycase',width:6,height:11,depth:2,shape:'keycase',basis:'example'},
    {id:'bottle350',width:6,height:16,depth:6,shape:'bottle',basis:'example'},
    {id:'bottle2000',width:10,height:31,depth:9,shape:'bottle',basis:'example'},
    {id:'card',width:8.56,height:5.398,depth:.076,shape:'card',basis:'standard'}
  ].map(Object.freeze));
  function objectShape(shape,w,h){
    const r=Math.min(w,h),stroke=Math.max(.15,r*.022),base=`fill="#f4f4ed" stroke="#727b62" stroke-width="${stroke}" stroke-linejoin="round"`,line=`fill="none" stroke="#89917b" stroke-width="${stroke}"`,rect=(x,y,ww,hh,rr=0)=>`<rect x="${x}" y="${y}" width="${ww}" height="${hh}" rx="${rr}"/>`;
    let body='';
    if(shape==='bottle')body=`<path d="M${w*.3} ${h*.1}L${w*.3} ${h*.18}C${w*.3} ${h*.24} 0 ${h*.25} 0 ${h*.35}V${h*.93}Q0 ${h} ${w*.15} ${h}H${w*.85}Q${w} ${h} ${w} ${h*.93}V${h*.35}C${w} ${h*.25} ${w*.7} ${h*.24} ${w*.7} ${h*.18}V${h*.1}Z"/>${rect(w*.27,0,w*.46,h*.11,w*.04)}<g ${line}>${[.4,.45,.75,.8,.87].map(n=>`<path d="M${w*.12} ${h*n}H${w*.88}"/>`).join('')}<path d="M${w*.18} ${h*.33}V${h*.92}" opacity=".45"/></g>${rect(w*.08,h*.5,w*.84,h*.18,w*.02)}`;
    else if(shape==='phone'||shape==='tablet')body=`${rect(0,0,w,h,r*.11)}<g ${line}>${rect(w*.055,h*.025,w*.89,h*.95,r*.08)}<path d="M${w*.34} ${h*.955}H${w*.66}"/></g>${shape==='phone'?`<rect x="${w*.34}" y="${h*.055}" width="${w*.32}" height="${h*.028}" rx="${h*.014}" fill="#8a9478" stroke="none"/>`:''}`;
    else if(shape==='laptop')body=`${rect(0,0,w,h,r*.065)}<g ${line}>${rect(w*.025,h*.035,w*.95,h*.925,r*.045)}<path d="M${w*.03} ${h*.91}H${w*.97} M${w*.38} ${h*.91}Q${w*.5} ${h*.99} ${w*.62} ${h*.91}"/></g>`;
    else if(shape==='paper'||shape==='book')body=`<path d="M0 0H${w*.8}L${w} ${h*.13}V${h}H0Z"/><g ${line}><path d="M${w*.8} 0V${h*.13}H${w} M${w*.13} ${h*.3}H${w*.8} M${w*.13} ${h*.4}H${w*.8} M${w*.13} ${h*.5}H${w*.63}"/>${shape==='book'?`<path d="M${w*.09} 0V${h}"/>`:''}</g>`;
    else if(shape==='wallet')body=`${rect(0,0,w,h,r*.1)}<g ${line}>${rect(w*.035,h*.06,w*.93,h*.87,r*.055)}<path d="M0 ${h*.35}H${w}"/></g>${rect(w*.76,h*.39,w*.24,h*.22,r*.05)}<circle cx="${w*.84}" cy="${h*.5}" r="${r*.025}" fill="#89917b"/>`;
    else if(shape==='umbrella')body=`<path d="M${w*.48} 0H${w*.52}L${w*.57} ${h*.065}Q${w*.92} ${h*.09} ${w} ${h*.17}L${w*.83} ${h*.83}H${w*.17}L0 ${h*.17}Q${w*.08} ${h*.09} ${w*.43} ${h*.065}Z"/>${rect(w*.25,h*.83,w*.5,h*.17,w*.13)}<g ${line}><path d="M${w*.5} ${h*.09}V${h*.81} M${w*.18} ${h*.17}L${w*.32} ${h*.81} M${w*.82} ${h*.17}L${w*.68} ${h*.81}"/></g>${rect(w*.06,h*.47,w*.88,h*.07,w*.02)}`;
    else if(shape==='glasses')body=`${rect(0,0,w,h,r*.48)}<g ${line}><path d="M0 ${h*.5}H${w} M${w*.2} ${h*.26}Q${w*.27} ${h*.11} ${w*.34} ${h*.26} M${w*.66} ${h*.26}Q${w*.73} ${h*.11} ${w*.8} ${h*.26}"/></g>`;
    else if(shape==='keycase')body=`${rect(0,0,w,h,r*.15)}<g ${line}><path d="M${w*.17} ${h*.04}V${h*.96} M${w*.77} ${h*.03}V${h*.96}"/></g><circle cx="${w*.4}" cy="${h*.23}" r="${r*.07}"/>`;
    else body=`${rect(0,0,w,h,r*.07)}<rect x="${w*.1}" y="${h*.28}" width="${w*.15}" height="${h*.22}" rx="${r*.025}" fill="#ccd2bf"/> <path d="M${w*.1} ${h*.71}H${w*.73} M${w*.1} ${h*.83}H${w*.4}" ${line}/>`;
    return `<g ${base}>${body}</g>`;
  }
  function presetIcon(item){
    const {width:w,height:h,shape}=item,phone=item.id==='phone',drawing=objectShape(shape,w,h);
    return phone?`<svg viewBox="-1 -1 ${h+2} ${w+2}" aria-hidden="true"><g transform="translate(${h} 0) rotate(90)">${drawing}</g></svg>`:`<svg viewBox="-1 -1 ${w+2} ${h+2}" aria-hidden="true">${drawing}</svg>`;
  }
  function geometry(bag,item,rotated=false,offset={x:0,y:0}){
    const scale=Math.min(270/Math.max(bag.width,item.width,item.height),210/Math.max(bag.height,item.width,item.height));
    const width=bag.width*scale,height=bag.height*scale,x=210-width/2,y=308-height;
    const iw=(rotated?item.height:item.width)*scale,ih=(rotated?item.width:item.height)*scale;
    const cx=clamp(x+width/2+(offset.x??0)*scale,24+iw/2,390-iw/2),cy=clamp(y+height-ih/2-4+(offset.y??0)*scale,25+ih/2,330-ih/2);
    return {scale,bag:{x,y,width,height},item:{x:cx-iw/2,y:cy-ih/2,width:iw,height:ih,cx,cy},handle:Math.min(52,height*.3)};
  }
  const bagKinds=Object.freeze(['shoulder','hobo','backpack','tote','sling','duffel','bucket','handbag','clutch','generic']);
  const kindRules=Object.freeze([
    ['hobo',/\bhobo\b|\bcrescent\b|\bhalf[ -]?moon\b|\bhalve[ -]?maan\b|ホーボー|半月|三日月|ホボ/i],
    ['backpack',/\bback[ -]?packs?\b|\brucksacks?\b|\bknapsacks?\b|\b(?:zain[oi]|zainett[oi])\b|\b(?:rugzak(?:ken)?|rugtas(?:sen)?)\b|リュック|バックパック|デイパック|ナップサック|後背包|双肩包|배낭|백팩/i],
    ['sling',/\bsling\b|\b(?:waist|belt|bum|body)[ -]?(?:bags?|packs?)\b|\bfanny[ -]?packs?\b|\bmarsupio?\b|\bheuptas(?:sen)?\b|ボディ[ー]?(?:バッグ|バック)|ウエスト(?:バッグ|バック|ポーチ)|ワンショルダー|腰包/i],
    ['duffel',/\bduff(?:el|le)\b|\bboston\b|\bweekender\b|\bgym[ -]?bags?\b|\bborson[ei]\b|\b(?:sport|reis)tas(?:sen)?\b|ボストン|ダッフル/i],
    ['bucket',/\bbucket\b|\bdrawstring\b|\bsecchiell[oi]\b|\bbuideltas(?:sen)?\b|バケット|バケツ|巾着|水桶包/i],
    ['clutch',/\bclutch(?:es)?\b|\bpouch(?:es)?\b|\bpochette\b|クラッチ|ポーチ/i],
    ['tote',/\btotes?\b|\bshopping[ -]?bags?\b|\bshoppers?\b|トート|托特包|토트/i],
    ['shoulder',/\bshoulder\b|\bcross[ -]?body\b|\bmessenger\b|\bsatchel\b|\ba\s+(?:tracolla|spalla)\b|\b(?:schouder|crossbody)tas(?:sen)?\b|ショルダー|クロスボディ|メッセンジャー|サコッシュ|斜背包|單肩包|单肩包|숄더/i],
    ['handbag',/\bhand[ -]?bags?\b|\btop[ -]?handle\b|\bbors[ae]\s+a\s+mano\b|\bhandtas(?:sen)?\b|ハンドバッグ|ハンドバック|手提包|핸드백/i]
  ]);
  function bagProfile(config={}){
    const override=config.shapeOverride,valid=override&&typeof override==='object'&&!Array.isArray(override)&&bagKinds.includes(override.kind);
    let kind=valid?override.kind:null,source=valid?'product':'fallback';
    const fields=[['title',norm(config.title)],['tags',(Array.isArray(config.tags)?config.tags:[]).map(norm).join(' ')],['type',norm(config.type)]];
    if(!kind){
      for(const generic of [false,true]){
        for(const [field,text] of fields){const match=kindRules.find(([name,re])=>(name==='handbag')===generic&&re.test(text));if(match){kind=match[0];source=field;break;}}
        if(kind)break;
      }
    }
    const defaults=kind==='hobo'?{scoop:.28,top_inset:.13,base_inset:.2}:{scoop:.035,top_inset:.16,base_inset:.12};
    const ranges={scoop:kind==='hobo'?[.12,.56]:[0,.08],top_inset:[.08,.34],base_inset:[.04,.35]};
    const profile={kind:kind??'generic',source,...defaults};
    if(valid)for(const key of Object.keys(ranges)){const n=override[key];if(typeof n==='number'&&Number.isFinite(n))profile[key]=clamp(n,...ranges[key]);}
    return profile;
  }
  function bagHandle(profile,geometry){
    const long=['shoulder','hobo','sling','bucket'].includes(profile.kind),short=['clutch','generic'].includes(profile.kind);
    return short?0:Math.min(geometry.bag.y-34,geometry.handle*(long?1.5:.8));
  }
  function bagShape(profile,w,h,handle){
    const p=profile??bagProfile(),kind=bagKinds.includes(p.kind)?p.kind:'generic',x=n=>fmt(n*w),y=n=>fmt(n*h),point=(a,b)=>`${x(a)} ${y(b)}`;
    const ink='#343832',seam='#72786a',weight=Math.min(6,Math.max(1.4,w*.025)),t=Number.isFinite(p.top_inset)?p.top_inset:.16,d=Number.isFinite(p.scoop)?p.scoop:.28,inset=Number.isFinite(p.base_inset)?p.base_inset:.12;
    const path=(d,attrs='')=>`<path d="${d}" ${attrs}/>`;
    const rounded=`M${point(.1,0)}H${x(.9)}Q${point(1,0)} ${point(1,.1)}V${y(.9)}Q${point(1,1)} ${point(.9,1)}H${x(.1)}Q${point(0,1)} ${point(0,.9)}V${y(.1)}Q${point(0,0)} ${point(.1,0)}Z`;
    let body=rounded,detail='',straps='';
    const loop=(left,right,rise,at=0)=>path(`M${point(left,at)}V${-rise*.48}C${x(left)} ${-rise} ${x(right)} ${-rise} ${x(right)} ${-rise*.48}V${y(at)}`);
    if(kind==='tote'){
      body=`M${point(0,0)}Q${point(.5,d*2)} ${point(1,0)}L${point(1-inset,1)}H${x(inset)}Z`;
      straps=loop(.25,.64,handle*.88,.1)+loop(.35,.75,handle,.1);
      detail=`M${point(.04,.1)}Q${point(.5,d*2+.1)} ${point(.96,.1)} M${point(.2,.06)}L${point(.24,.25)} M${point(.8,.06)}L${point(.76,.25)}`;
    }else if(kind==='hobo'){
      body=`M${point(t,0)}C${point(t,d*.8)} ${point(.28,d)} ${point(.5,d)}C${point(.72,d)} ${point(1-t,d*.8)} ${point(1-t,0)}L${point(1,.74)}Q${point(1,.8)} ${point(.92,.86)}L${point(1-inset,1)}H${x(inset)}L${point(.08,.86)}Q${point(0,.8)} ${point(0,.74)}Z`;
      straps=loop(t,1-t,handle,.015);
      detail=`M${point(t+.018,.07)}C${point(t+.018,d*.8+.04)} ${point(.28,d+.04)} ${point(.5,d+.04)}C${point(.72,d+.04)} ${point(1-t-.018,d*.8+.04)} ${point(1-t-.018,.07)} M${point(.5,d+.06)}V${y(.95)}`;
    }else if(kind==='backpack'){
      body=`M${point(.5,0)}C${point(.18,0)} ${point(0,.18)} ${point(0,.4)}V${y(.9)}Q${point(0,1)} ${point(.1,1)}H${x(.9)}Q${point(1,1)} ${point(1,.9)}V${y(.4)}C${point(1,.18)} ${point(.82,0)} ${point(.5,0)}Z`;
      straps=loop(.4,.6,handle*.42,.035)+path(`M${point(.24,.08)}Q${point(.02,.15)} ${point(.03,.65)}L${point(.16,.9)} M${point(.76,.08)}Q${point(.98,.15)} ${point(.97,.65)}L${point(.84,.9)}`);
      detail=`M${point(.1,.4)}C${point(.1,.12)} ${point(.9,.12)} ${point(.9,.4)} M${point(.17,.58)}H${x(.83)}V${y(.86)}Q${point(.83,.9)} ${point(.78,.9)}H${x(.22)}Q${point(.17,.9)} ${point(.17,.86)}Z M${point(.2,.64)}H${x(.8)} M${point(.73,.64)}V${y(.7)}`;
    }else if(kind==='sling'){
      body=`M${point(.33,0)}C${point(.7,0)} ${point(1,.2)} ${point(1,.42)}V${y(.72)}C${point(1,.94)} ${point(.76,1)} ${point(.42,1)}C${point(.13,1)} ${point(0,.8)} ${point(0,.6)}V${y(.24)}C${point(0,.09)} ${point(.16,0)} ${point(.33,0)}Z`;
      straps=path(`M${point(.16,.2)}L${x(.16)} ${-handle*.6}Q${x(.16)} ${-handle} ${x(.5)} ${-handle}L${point(.89,.5)}`);
      detail=`M${point(.14,.22)}L${point(.82,.59)} M${point(.16,.48)}L${point(.74,.78)} M${point(.7,.75)}L${point(.66,.82)}`;
    }else if(kind==='duffel'){
      body=`M${point(.2,0)}H${x(.8)}Q${point(1,0)} ${point(1,.5)}V${y(.8)}Q${point(1,1)} ${point(.8,1)}H${x(.2)}Q${point(0,1)} ${point(0,.8)}V${y(.5)}Q${point(0,0)} ${point(.2,0)}Z`;
      straps=loop(.3,.62,handle*.8,.3)+loop(.38,.7,handle,.3);
      detail=`M${point(.18,.1)}V${y(.92)} M${point(.82,.1)}V${y(.92)} M${point(.25,.12)}H${x(.75)} M${point(.31,.24)}V${y(.91)} M${point(.69,.24)}V${y(.91)}`;
    }else if(kind==='bucket'){
      body=`M${point(.08,0)}H${x(.92)}L${point(1,.85)}Q${point(1,1)} ${point(.85,1)}H${x(.15)}Q${point(0,1)} ${point(0,.85)}Z`;
      straps=loop(.1,.9,handle,.12);
      detail=`M${point(.12,.11)}Q${point(.5,.21)} ${point(.88,.11)} M${point(.12,.2)}Q${point(.5,.28)} ${point(.88,.2)} M${point(.48,.23)}L${point(.4,.5)} M${point(.52,.23)}L${point(.63,.47)}`;
    }else if(kind==='handbag'){
      body=`M${point(.16,0)}H${x(.84)}L${point(1,.9)}Q${point(1,1)} ${point(.9,1)}H${x(.1)}Q${point(0,1)} ${point(0,.9)}Z`;
      straps=loop(.3,.64,handle*.72,.13)+loop(.36,.7,handle*.9,.13);
      detail=`M${point(.18,.17)}H${x(.82)} M${point(.47,.17)}V${y(.33)}H${x(.53)}V${y(.17)}`;
    }else if(kind==='shoulder'){
      straps=loop(.08,.92,handle,.18);
      detail=`M${point(.03,.12)}L${point(.1,.51)}Q${point(.5,.64)} ${point(.9,.51)}L${point(.97,.12)} M${point(.47,.52)}V${y(.68)}H${x(.53)}V${y(.52)}`;
    }else if(kind==='clutch'){
      detail=`M${point(.03,.1)}L${point(.5,.56)}L${point(.97,.1)} M${point(.47,.56)}H${x(.53)}`;
    }else detail=`M${point(.06,.1)}H${x(.94)}`;
    return `<g data-nba-bag-shape="${kind}" aria-hidden="true"><g fill="none" stroke="${ink}" stroke-width="${weight}" stroke-linecap="round" stroke-linejoin="round">${straps}</g>${path(body,`data-nba-bag-body fill="${ink}"`)}${path(detail,`fill="none" stroke="${seam}" stroke-width="${Math.min(1.2,Math.max(.6,w*.008))}" stroke-linecap="round" stroke-linejoin="round"`)}</g>`;
  }
  function languageKey(v){const s=String(v??'').replace(/_/g,'-').toLowerCase().split('-')[0];return s==='zh'?'zh-TW':['ja','en','ko','es','de','fr','th','id','it','nl'].includes(s)?s:'en';}
  const Core={axis,value,parseLines,normalize,catalog,objectShape,geometry,languageKey,bagKinds,bagProfile,bagHandle,bagShape};
  if(typeof module==='object'&&module.exports)module.exports=Core;
  if(typeof window==='undefined'||!window.customElements||customElements.get('nano-bag-advisor'))return;
  let serial=0;
  class NanoBagAdvisor extends HTMLElement {
    connectedCallback(){
      if(this.ready)return;
      try{
        this.config=JSON.parse(this.dataset.config);this.pageLanguage=languageKey(this.config.locale);this.language=this.pageLanguage;
        const parsed=new DOMParser().parseFromString(this.config.description??'','text/html');
        const tables=[...parsed.querySelectorAll('table')].map(t=>[...t.rows].map(r=>[...r.cells].map(c=>c.textContent.trim())));
        parsed.querySelectorAll('table,script,style').forEach(el=>el.remove());parsed.querySelectorAll('br').forEach(el=>el.replaceWith('\n'));
        const lines=[...parsed.querySelectorAll('p,li,div,h3')].filter(el=>!el.querySelector('p,li,div,h3')).map(el=>el.textContent).join('\n');
        this.data=normalize(this.config,lines||parsed.body.textContent,tables);
        this.ready=true;if(!this.data.supported)return;
        this.uid='nba-'+(++serial);this.bagIndex=0;this.itemId='bottle500';this.custom={};this.rotated=false;this.offset={x:0,y:0};
        this.launch=this.querySelector('[data-nba-open]');this.launch.addEventListener('click',()=>this.open());this.updateLauncher();this.hidden=false;
      }catch{this.hidden=true;}
    }
    disconnectedCallback(){if(this.dialog?.open)this.dialog.close();this.unlock();}
    t(k){const v=(this.language===this.pageLanguage?this.config.i18n?.[k]:null)??this.config.languages?.[this.language]?.strings?.[k]??this.config.languages?.en?.strings?.[k]??k;return String(v).replace(/&(amp|lt|gt|quot|apos|#39|#x27);/g,(_,x)=>({amp:'&',lt:'<',gt:'>',quot:'"',apos:"'",'#39':"'",'#x27':"'"}[x]));}
    text(k){return esc(this.t(k));}
    item(){return {...catalog.find(i=>i.id===this.itemId),...this.custom[this.itemId]};}
    bag(){return this.data.rows[this.bagIndex];}
    updateLauncher(){this.launch.querySelector('strong').textContent=this.t('title');this.launch.querySelector('small').textContent=this.t('launch_hint');this.launch.lang=this.language;}
    unlock(){if(this.previousOverflow!==undefined){document.body.style.overflow=this.previousOverflow;this.previousOverflow=undefined;}}
    open(){
      if(this.dialog?.open)return;
      if(!this.dialog){
        this.dialog=document.createElement('dialog');this.dialog.className='nba-dialog';this.dialog.setAttribute('aria-labelledby',this.uid+'-title');
        this.dialog.innerHTML='<header class="nba-head"></header><div class="nba-body"></div><p class="nba-sr" role="status" aria-live="polite" data-nba-status></p>';this.append(this.dialog);
        this.dialog.addEventListener('click',e=>this.click(e));this.dialog.addEventListener('change',e=>this.change(e));this.dialog.addEventListener('keydown',e=>this.key(e));
        this.dialog.addEventListener('pointerdown',e=>this.pointerStart(e));this.dialog.addEventListener('pointermove',e=>this.pointerMove(e));
        this.dialog.addEventListener('pointerup',()=>this.pointerEnd());this.dialog.addEventListener('pointercancel',()=>this.pointerEnd());
        this.dialog.addEventListener('close',()=>{this.pointerEnd();this.unlock();if(this.isConnected)this.launch.focus({preventScroll:true});});
      }
      if(this.data.sizeIndex>=0&&this.data.rows.length>1){const root=this.closest('[data-product-id]'),inputs=root?[...root.querySelectorAll('[data-variant-input][data-index="option'+(this.data.sizeIndex+1)+'"]')]:[],v=inputs.find(el=>el.tagName==='SELECT'||el.checked)?.value,index=this.data.rows.findIndex(r=>r.label===v);if(index>=0)this.bagIndex=index;}
      this.render();this.previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';this.dialog.showModal();this.dialog.querySelector('[data-nba-close]').focus();
    }
    render(){
      const body=this.dialog.querySelector('.nba-body'),scroll=body.scrollTop,railScroll=body.querySelector('.nba-presets')?.scrollLeft??0,adjust=body.querySelector('.nba-adjust')?.open??false;
      this.dialog.lang=this.language;
      this.dialog.querySelector('.nba-head').innerHTML=`<div class="nba-head-title"><div class="nba-eyebrow">NANOSTUDIO · SIZE GUIDE</div><h2 id="${this.uid}-title">${this.text('title')}</h2></div><select class="nba-language" data-nba-language aria-label="${this.text('language')}">${Object.entries(this.config.languages).map(([code,p])=>`<option value="${esc(code)}" lang="${esc(code)}" ${code===this.language?'selected':''}>${esc(p.name)}</option>`).join('')}</select><button type="button" class="nba-close" data-nba-close aria-label="${this.text('close')}">×</button>`;
      const bag=this.bag(),item=this.item(),labels=this.data.rows.length>1?`<label class="nba-field"><span>${this.text('bag_size')}</span><select data-nba-bag>${this.data.rows.map((r,i)=>`<option value="${i}" ${i===this.bagIndex?'selected':''}>${esc(r.label)}</option>`).join('')}</select></label>`:'';
      const dimensions=axes.filter(k=>bag[k]).map(k=>`<span>${this.text(k)}<b>${fmt(bag[k])} cm</b></span>`).join('');
      body.innerHTML=`<p class="nba-product">${esc(this.config.title)}</p>${labels}<div class="nba-dimensions">${dimensions}</div><div class="nba-stage" data-nba-stage>${this.diagram()}</div><div class="nba-toolbar"><button type="button" data-nba-action="rotate"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4 7a7 7 0 1 1-1 6 M4 2v5h5"/></svg>${this.text('rotate')}</button><button type="button" data-nba-action="reset">${this.text('reset')}</button></div><p class="nba-hint">${this.text('move_hint')}</p><label class="nba-field"><span>${this.text('choose')}</span><select data-nba-item>${catalog.map(i=>`<option value="${i.id}" ${i.id===this.itemId?'selected':''}>${this.text(i.id)}</option>`).join('')}</select></label><div class="nba-presets" role="group" aria-label="${this.text('choose')}">${catalog.map(i=>`<button type="button" class="nba-preset" data-nba-preset="${i.id}" aria-pressed="${i.id===this.itemId}">${presetIcon(i)}<span>${this.text(i.id)}</span></button>`).join('')}</div><div class="nba-item-summary"><strong>${this.text(this.itemId)}</strong><span>${fmt(item.width)} × ${fmt(item.height)} × ${fmt(item.depth)} cm</span></div><p class="nba-reference">${this.custom[this.itemId]?this.text('custom_note'):item.basis==='manufacturer'?`${this.text('manufacturer_note')} <a href="${esc(item.source)}" target="_blank" rel="noopener noreferrer">${this.text('source')}</a>`:this.text(item.basis==='example'?'example_note':item.basis==='paper'?'paper_note':'standard_note')}</p><details class="nba-adjust" ${adjust?'open':''}><summary>${this.text('adjust')}</summary><div class="nba-adjust-grid">${axes.map(k=>`<label class="nba-field"><span>${this.text(k)} (cm)</span><input type="number" inputmode="decimal" min="0.01" max="100" step="0.01" value="${fmt(item[k])}" data-nba-dim="${k}"></label>`).join('')}</div><p class="nba-error" role="alert" data-nba-error hidden></p><button type="button" class="nba-apply" data-nba-action="apply">${this.text('apply')}</button></details><p class="nba-note">${this.text('comparison_note')}</p>`;
      body.querySelector('[data-nba-stage] svg').setAttribute('role','group');
      body.scrollTop=scroll;body.querySelector('.nba-presets').scrollLeft=railScroll;
    }
    diagram(){
      const bag=this.bag(),item=this.item(),g=geometry(bag,item,this.rotated,this.offset),b=g.bag,a=g.item,s=g.scale,profile=bagProfile(this.config),handle=bagHandle(profile,g);
      const x1=b.x,x2=b.x+b.width,y1=b.y,y2=b.y+b.height,top=y1-handle-14;
      const transformed=this.rotated?`translate(${a.cx} ${a.cy}) rotate(90) scale(${s}) translate(${-item.width/2} ${-item.height/2})`:`translate(${a.x} ${a.y}) scale(${s})`;
      return `<svg viewBox="0 0 420 354" role="img" aria-label="${this.text('diagram_label')}"><title>${this.text('diagram_label')}</title><defs><marker id="${this.uid}-arrow" viewBox="0 0 10 10" refX="5" refY="5" markerWidth="5" markerHeight="5" orient="auto-start-reverse"><path d="M0 0L10 5L0 10Z" fill="#7c836f"/></marker></defs><g transform="translate(${x1} ${y1})" data-nba-shape-source="${profile.source}">${bagShape(profile,b.width,b.height,handle)}</g><g stroke="#919982" stroke-width="1" fill="none"><path d="M${x1} ${top}H${x2}" marker-start="url(#${this.uid}-arrow)" marker-end="url(#${this.uid}-arrow)"/><path d="M${x1-14} ${y1}V${y2}" marker-start="url(#${this.uid}-arrow)" marker-end="url(#${this.uid}-arrow)"/><path d="M${x1-5} ${y1}H${x1-19} M${x1-5} ${y2}H${x1-19}" opacity=".5"/></g><text class="nba-svg-dimension" text-anchor="middle" x="${x1+b.width/2}" y="${top-9}">${fmt(bag.width)} cm</text><text class="nba-svg-dimension" text-anchor="middle" transform="translate(${x1-23} ${y1+b.height/2}) rotate(-90)">${fmt(bag.height)} cm</text><g class="nba-item" data-nba-object tabindex="0" role="button" aria-label="${this.text(this.itemId)} — ${this.text('move_hint')}" transform="${transformed}"><rect class="nba-hit" x="-0.2" y="-0.2" width="${item.width+.4}" height="${item.height+.4}" rx=".5"/>${objectShape(item.shape,item.width,item.height)}</g><path d="M80 332H340" stroke="#e0e4d8" stroke-width="1"/></svg>`;
    }
    redraw(){const focus=this.dialog.querySelector('[data-nba-object]')===document.activeElement;this.dialog.querySelector('[data-nba-stage]').innerHTML=this.diagram();this.dialog.querySelector('[data-nba-stage] svg').setAttribute('role','group');if(focus)this.dialog.querySelector('[data-nba-object]').focus({preventScroll:true});}
    announce(k){this.dialog.querySelector('[data-nba-status]').textContent=this.t(k);}
    choose(id){if(!catalog.some(i=>i.id===id))return;this.itemId=id;this.rotated=id==='phone';this.offset={x:0,y:0};this.render();this.announce('updated');}
    change(e){
      if(e.target.matches('[data-nba-language]')){
        const lang=e.target.value;if(!Object.hasOwn(this.config.languages,lang)||lang===this.language)return;
        const drafts=[...this.dialog.querySelectorAll('[data-nba-dim]')].map(el=>({key:el.dataset.nbaDim,value:el.value,invalid:el.getAttribute('aria-invalid')})),oldError=this.dialog.querySelector('[data-nba-error]'),showError=oldError&&!oldError.hidden;
        this.language=lang;this.render();this.updateLauncher();
        for(const d of drafts){const el=this.dialog.querySelector('[data-nba-dim="'+d.key+'"]');if(el){el.value=d.value;if(d.invalid)el.setAttribute('aria-invalid',d.invalid);}}
        if(showError){const el=this.dialog.querySelector('[data-nba-error]');el.hidden=false;el.textContent=this.t('dimension_error');}
        this.announce('updated');this.dialog.querySelector('[data-nba-language]').focus({preventScroll:true});
      }
      if(e.target.matches('[data-nba-item]')){this.choose(e.target.value);this.dialog.querySelector('[data-nba-item]').focus({preventScroll:true});}
      if(e.target.matches('[data-nba-bag]')){const i=Number(e.target.value);if(!Number.isInteger(i)||!this.data.rows[i])return;this.bagIndex=i;this.offset={x:0,y:0};this.render();this.dialog.querySelector('[data-nba-bag]').focus({preventScroll:true});}
    }
    click(e){
      if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();return;}
      const button=e.target.closest('button');if(!button)return;
      if(button.hasAttribute('data-nba-close'))this.dialog.close();
      if(button.dataset.nbaPreset){this.choose(button.dataset.nbaPreset);this.dialog.querySelector('[data-nba-preset="'+this.itemId+'"]').focus({preventScroll:true});}
      if(button.dataset.nbaAction==='rotate'){this.rotated=!this.rotated;this.offset={x:0,y:0};this.redraw();this.announce('updated');}
      if(button.dataset.nbaAction==='reset'){this.rotated=this.itemId==='phone';this.offset={x:0,y:0};delete this.custom[this.itemId];this.render();this.dialog.querySelector('[data-nba-action="reset"]').focus({preventScroll:true});this.announce('updated');}
      if(button.dataset.nbaAction==='apply'){
        const inputs=[...this.dialog.querySelectorAll('[data-nba-dim]')],valid=inputs.every(el=>el.value!==''&&Number.isFinite(Number(el.value))&&Number(el.value)>=.01&&Number(el.value)<=100);
        inputs.forEach(el=>el.removeAttribute('aria-invalid'));
        if(!valid){const error=this.dialog.querySelector('[data-nba-error]');error.hidden=false;error.textContent=this.t('dimension_error');const bad=inputs.find(el=>el.value===''||!Number.isFinite(Number(el.value))||Number(el.value)<.01||Number(el.value)>100);bad.setAttribute('aria-invalid','true');bad.focus();return;}
        this.custom[this.itemId]=Object.fromEntries(inputs.map(el=>[el.dataset.nbaDim,Number(el.value)]));this.offset={x:0,y:0};this.render();this.dialog.querySelector('[data-nba-action="apply"]').focus({preventScroll:true});this.announce('updated');
      }
    }
    key(e){
      if(e.target.matches('[data-nba-dim]')&&e.key==='Enter'){e.preventDefault();this.dialog.querySelector('[data-nba-action="apply"]').click();return;}
      if(!e.target.closest('[data-nba-object]'))return;
      const moves={ArrowLeft:[-1,0],ArrowRight:[1,0],ArrowUp:[0,-1],ArrowDown:[0,1]},m=moves[e.key];
      if(m){e.preventDefault();this.offset.x=clamp(this.offset.x+m[0]*(e.shiftKey?5:1),-100,100);this.offset.y=clamp(this.offset.y+m[1]*(e.shiftKey?5:1),-100,100);this.redraw();}
      if(e.key===' '||e.key==='Enter'){e.preventDefault();this.rotated=!this.rotated;this.offset={x:0,y:0};this.redraw();this.announce('updated');}
    }
    pointerStart(e){
      if(e.button!==0||!e.target.closest('[data-nba-object]'))return;
      const svg=this.dialog.querySelector('[data-nba-stage] svg');this.drag={pointerId:e.pointerId,x:e.clientX,y:e.clientY,offset:{...this.offset},factor:1/svg.getScreenCTM().a/geometry(this.bag(),this.item(),this.rotated,this.offset).scale};this.dialog.setPointerCapture(e.pointerId);e.preventDefault();
    }
    pointerMove(e){if(!this.drag||e.pointerId!==this.drag.pointerId)return;const d=this.drag;this.offset={x:clamp(d.offset.x+(e.clientX-d.x)*d.factor,-100,100),y:clamp(d.offset.y+(e.clientY-d.y)*d.factor,-100,100)};this.redraw();}
    pointerEnd(){if(this.drag){if(this.dialog.hasPointerCapture(this.drag.pointerId))this.dialog.releasePointerCapture(this.drag.pointerId);this.drag=null;}}
  }
  customElements.define('nano-bag-advisor',NanoBagAdvisor);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["element.select"] && !Shopify.designMode) return;
  try {
    // Custom element for select button functionality
  class ElementSelect extends HTMLElement {
    constructor() {
      super();
      this.select = null;
      this.buttonText = null;
      this.button = null;
    }

    connectedCallback() {
      // Wait for DOM to be ready
      this.select = this.querySelector('select');
      this.button = this.querySelector('.element-button');
      
      if (this.select && this.button) {
        this.init();
      }
    }

    init() {
      // Find the button text element within the element.button
      this.buttonText = this.button.querySelector('.element-button__text') || this.button.querySelector('[data-button-text]');
      
      // Set initial text
      this.updateButtonText();
      
      // Add click handler to button to trigger select
      this.button.addEventListener('click', (e) => this.handleButtonClick(e));
      
      // Add keyboard handler for the select element
      this.select.addEventListener('keydown', (e) => this.handleKeydown(e));
      
      // Update on change
      this.select.addEventListener('change', () => this.updateButtonText());
      
      // Update on focus for better UX
      this.select.addEventListener('focus', () => this.handleFocus());
      this.select.addEventListener('blur', () => this.handleBlur());
    }

    handleButtonClick(e) {
      // Prevent default button behavior
      e.preventDefault();
      e.stopPropagation();
      
      // Trigger the native select
      this.select.focus();
      this.select.click();
    }

    handleKeydown(e) {
      // Handle keyboard navigation for the select
      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault();
          this.select.click();
          break;
        case 'ArrowDown':
        case 'ArrowUp':
          // Let the native select handle arrow key navigation
          break;
        default:
          // Let other keys pass through
          break;
      }
    }

    updateButtonText() {
      if (!this.buttonText) return;
      
      const selectedOption = this.select.options[this.select.selectedIndex];
      if (selectedOption && selectedOption.value !== '') {
        this.buttonText.textContent = selectedOption.textContent;
      } else {
        this.buttonText.textContent = this.select.getAttribute('aria-label') || 'Select an option';
      }
    }

    handleFocus() {
      this.classList.add('element-select__wrapper--focused');
    }

    handleBlur() {
      this.classList.remove('element-select__wrapper--focused');
    }

    disconnectedCallback() {
      // Clean up event listeners
      if (this.button) {
        this.button.removeEventListener('click', (e) => this.handleButtonClick(e));
      }
      if (this.select) {
        this.select.removeEventListener('keydown', (e) => this.handleKeydown(e));
        this.select.removeEventListener('change', () => this.updateButtonText());
        this.select.removeEventListener('focus', () => this.handleFocus());
        this.select.removeEventListener('blur', () => this.handleBlur());
      }
    }
  }

  // Register the custom element
  customElements.define('element-select', ElementSelect);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.findSubmitButton();
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    findSubmitButton() {
      // Look for submit button in the form
      const submitButton = this.form.querySelector('button[type="submit"], input[type="submit"]');
      return submitButton;
    }

    disableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.classList.add('product-form__submit-button--pulsing');
      }
    }

    enableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = false;
        this.submitButton.classList.remove('product-form__submit-button--pulsing');
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      // Disable submit button and start pulsing
      this.disableSubmitButton();

      // Get cart state before form submission
      let cartBeforeSubmission;
      try {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        cartBeforeSubmission = await cartResponse.json();
      } catch (error) {
        console.error('Failed to get cart state before submission:', error);
        cartBeforeSubmission = null;
      }

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      };

      const formData = new FormData(this.form);

      // Dispatch event allowing subscribers to modify formData
      this.dispatchEvent(
        new CustomEvent('product-form:submit:before', {
          bubbles: true,
          detail: {
            form: formData,
          },
          cancelable: true
        })
      );

      // Wait for the next tick to allow async event listeners to complete
      // This ensures all synchronous and microtask listeners have finished
      await new Promise(resolve => {
        // Use queueMicrotask for better performance than setTimeout
        queueMicrotask(resolve);
      });

      config.body = formData;

      // Dispatch event allowing subscribers to handle cart request themselves
      const cartRequestEvent = new CustomEvent('product-form:cart:request', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: formData,
          config: config,
          cartBefore: cartBeforeSubmission,
          resolve: (responseData) => this.resolveCartRequest(responseData),
          reject: (error) => this.rejectCartRequest(error)
        }
      });

      const cartRequestHandled = !this.dispatchEvent(cartRequestEvent);
      let responseData;

      try {
        if (cartRequestHandled) {
          // Event was cancelled, meaning a subscriber handled the cart request
          // We need to wait for them to provide the response data
          responseData = await this.waitForCartResponse();
        } else {
          // No subscriber handled it, proceed with default behavior
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, config);       
          responseData = await response.json();

          if (!response.ok) {
            throw responseData;
          }
        }

        // Get updated cart state after form submission
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        const cartAfterSubmission = await cartResponse.json();

        this.dispatchEvent(
          new CustomEvent('product-form:submit:success', {
            bubbles: true,
            detail: {
              form: formData,
              response: responseData,
              cart: cartAfterSubmission
            },
          })
        );

        // Only fire cart:update if there's a change from this specific submission
        if (this.hasCartChanged(cartBeforeSubmission, cartAfterSubmission)) {
          this.dispatchEvent(
            new CustomEvent('product-form:cart:update', {
              bubbles: true,
              detail: {
                cart: cartAfterSubmission,
                form: formData,
                response: responseData
              },
            })
          );
        }

        // Navigate to cart unless prevented by another event handler
        const cartNavigationEvent = new CustomEvent('product-form:cart:navigate', {
          bubbles: true,
          cancelable: true,
          detail: {
            form: formData,
            response: responseData,
            cart: cartAfterSubmission
          }
        });

        const navigationPrevented = !this.dispatchEvent(cartNavigationEvent);
        
        if (!navigationPrevented) {
          window.location.href = `${window.Shopify.routes.root}cart`;
        }
      } catch (error) {
        this.dispatchEvent(
          new CustomEvent('product-form:submit:error', {
            bubbles: true,
            detail: {
              form: formData,
              cart: cartBeforeSubmission,
              error: error
            },
          })
        );
      } finally {
        // Re-enable submit button and stop pulsing
        this.enableSubmitButton();
      }
    }

    /**
     * Waits for a subscriber to provide cart response data after handling the cart request
     * @returns {Promise<Object>} The cart response data
     */
    waitForCartResponse() {
      return new Promise((resolve, reject) => {
        // Store the resolver for this request
        this._cartRequestResolver = { resolve, reject };
        
        // Set a timeout to prevent hanging
        const timeout = setTimeout(() => {
          if (this._cartRequestResolver) {
            delete this._cartRequestResolver;
            reject(new Error('Cart request timeout - no response received from subscriber'));
          }
        }, 30000); // 30 second timeout
        
        // Store timeout reference for cleanup
        this._cartRequestResolver.timeout = timeout;
      });
    }

    /**
     * Resolves a pending cart request with response data
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Object} responseData - The cart response data
     */
    resolveCartRequest(responseData) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.resolve(responseData);
        delete this._cartRequestResolver;
      }
    }

    /**
     * Rejects a pending cart request with an error
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Error} error - The error that occurred
     */
    rejectCartRequest(error) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.reject(error);
        delete this._cartRequestResolver;
      }
    }

    hasCartChanged(cartBefore, cartAfter) {
      if (!cartBefore || !cartAfter) {
        return true; // If we can't compare, assume there's a change
      }

      // Deep comparison using JSON.stringify for simplicity
      // This handles all nested changes automatically
      return JSON.stringify(cartBefore) !== JSON.stringify(cartAfter);
    }
  }

  customElements.define('product-form', ProductForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product.messages"] && !Shopify.designMode) return;
  try {
    class ProductFormMessages extends HTMLElement {
    constructor() {
      super();
      
      // Pull localized error message from data attributes
      this.formId = this.dataset.formId;
      this.defaultErrorMessage = this.dataset.error;
      this.defaultSuccessMessage = this.dataset.success;
      
      // Create abort controller for event cleanup
      this.abortController = new AbortController();
    }

    connectedCallback() {
      // Cache the template content for better performance
      this.cacheTemplate();
      this.bindEvents();
    }

    disconnectedCallback() {
      // Clean up event listeners when component is removed
      this.abortController.abort();
    }

    cacheTemplate() {
      const template = this.querySelector('template');
      if (template) {
        this.template = template.innerHTML;
        this.templateElement = template;
      }
    }

    bindEvents() {
      const { signal } = this.abortController;
      
      // Listen for form submission start to clear error messages
      document.addEventListener('product-form:submit:before', this.handleSubmitStart.bind(this), { signal });
      
      // Listen for form errors
      document.addEventListener('product-form:submit:error', this.handleError.bind(this), { signal });

      // Listen for form success
      document.addEventListener('product-form:submit:success', this.handleSuccess.bind(this), { signal });
    }

    handleSubmitStart(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      this.clearMessages();
    }

    handleSuccess(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      let message = this.defaultSuccessMessage;

      const successMessageEvent = new CustomEvent('product-form:message:success', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      // Dispatch the event and check if it was cancelled
      const eventCancelled = !this.dispatchEvent(successMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(successMessageEvent.detail.message);
    }

    handleError(e) { 
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      const error = e.detail.error;
      let message = this.defaultErrorMessage;
      
      // Use server response message if available (already localized)
      if (error.description) {
        message = error.description;
      } else if (error.message) {
        message = error.message;
      }

      const errorMessageEvent = new CustomEvent('product-form:message:error', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      const eventCancelled = !this.dispatchEvent(errorMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(errorMessageEvent.detail.message);
    }

    showMessage(message) {
      // Clear existing error messages
      this.clearMessages();
      this.classList.remove('hide');
      
      // Use cached template content and replace <slot> with the error message
      if (this.template) {
        const messageContent = this.template.replace('<slot></slot>', message);
        
        // Insert the error message content
        this.innerHTML = messageContent;
      }
    }

    clearMessages() {
      this.classList.add('hide');

      // Restore the original template structure using cached template
      if (this.templateElement) {
        this.innerHTML = this.templateElement.outerHTML;
      }
    }
  }

  customElements.define('product-form-messages', ProductFormMessages);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kit.popover"] && !Shopify.designMode) return;
  try {
    class KitPopover extends HTMLElement {
    #abortController = null;

    connectedCallback() {
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      // Prevent flash of previously-positioned popover
      this.addEventListener(
        'beforetoggle',
        (event) => {
          if (event.newState === 'open') {
            this.style.visibility = 'hidden';
          }
        },
        { signal }
      );

      this.addEventListener(
        'toggle',
        (event) => {
          if (event.newState === 'open') {
            this.#position();
            this.style.visibility = '';
          }
        },
        { signal }
      );

      window.addEventListener(
        'resize',
        () => {
          if (this.matches(':popover-open')) this.#position();
        },
        { signal, passive: true }
      );

      this.addEventListener(
        'click',
        (event) => {
          if (event.target.closest('a[href], button:not([popovertarget])')) {
            this.hidePopover();
          }
        },
        { signal }
      );
    }

    disconnectedCallback() {
      this.#abortController?.abort();
    }

    #position() {
      const trigger = document.querySelector(`[popovertarget="${this.id}"]`);
      if (!trigger) return;

      const placement = this.getAttribute('placement') || 'bottom-start';
      const isRTL = getComputedStyle(this).direction === 'rtl';
      const gap = Number(this.getAttribute('gap') ?? 4);
      const margin = 4;

      const triggerRect = trigger.getBoundingClientRect();
      const popoverWidth = this.offsetWidth;
      const popoverHeight = this.offsetHeight;

      const [axis, alignment] = placement.split('-');

      let top = axis === 'bottom' ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap;
      let resolvedAxis = axis;

      // Auto-flip vertically if overflowing viewport
      if (axis === 'bottom' && top + popoverHeight > window.innerHeight - margin) {
        top = triggerRect.top - popoverHeight - gap;
        resolvedAxis = 'top';
      } else if (axis === 'top' && top < margin) {
        top = triggerRect.bottom + gap;
        resolvedAxis = 'bottom';
      }

      const alignStart = isRTL ? 'end' : 'start';
      let left;
      if (alignment === 'center') {
        left = triggerRect.left + (triggerRect.width - popoverWidth) / 2;
      } else if (alignment === alignStart) {
        left = triggerRect.left;
      } else {
        left = triggerRect.right - popoverWidth;
      }

      // Clamp horizontally to viewport
      if (left < margin) {
        left = margin;
      } else if (left + popoverWidth > window.innerWidth - margin) {
        left = window.innerWidth - popoverWidth - margin;
      }

      this.style.transformOrigin = resolvedAxis === 'bottom' ? 'top' : 'bottom';

      // Convert to document coordinates so popover scrolls with page
      this.style.top = `${Math.round(top + window.scrollY)}px`;
      this.style.left = `${Math.round(left + window.scrollX)}px`;
    }
  }

  customElements.define('kit-popover', KitPopover);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.grid"] && !Shopify.designMode) return;
  try {
    class LayoutGrid extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-grid', LayoutGrid);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.stack"] && !Shopify.designMode) return;
  try {
    class LayoutStack extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-stack', LayoutStack);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.sticky-scroller"] && !Shopify.designMode) return;
  try {
    class StickyScroller extends HTMLElement {
    constructor() {
      super()
      this.resizeObserver = new ResizeObserver(() => this.recalculateStyles())
      this.abortController = new AbortController()
      this.isScrolling = false
      this.position = 'relative'
      this.lastKnownScrollY = 0
      this.initialTop = 0
      this.currentTop = 0
      this.boundOnScroll = this.onScroll.bind(this)
    }

    connectedCallback() {
      this.inView(this, this.setupObservers.bind(this), { margin: '500px' })
    }

    disconnectedCallback() {
      this.cleanupObservers()
    }

    setupObservers() {
      this.resizeObserver.observe(this)
      window.addEventListener('scroll', this.boundOnScroll, { passive: true, signal: this.abortController.signal })
      return this.cleanupObservers.bind(this)
    }

    cleanupObservers() {
      this.abortController.abort()
      this.resizeObserver.disconnect()
    }

    onScroll() {
      if (!this.isScrolling) {
        requestAnimationFrame(() => {
          this.updatePosition()
          this.isScrolling = false
        })
        this.isScrolling = true
      }
    }

    recalculateStyles() {
      this.style.removeProperty('top')
      const { top, position } = getComputedStyle(this)
      this.initialTop = parseInt(top, 10)
      this.position = position
      this.updatePosition()
    }

    updatePosition() {
      if (this.position !== 'sticky') {
        this.style.removeProperty('top')
        return
      }

      const { top, height } = this.getBoundingClientRect()
      const maxTop = top + window.scrollY - this.offsetTop + this.initialTop
      const minTop = height - window.innerHeight + 20

      this.currentTop += this.lastKnownScrollY - window.scrollY
      this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.initialTop)

      this.lastKnownScrollY = window.scrollY
      this.style.top = `${Math.round(this.currentTop)}px`
    }
    
    /**
     * Original source from https://www.npmjs.com/package/@motionone/dom
     * Usage: https://motion.dev/dom/in-view
     */
    inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = 'any' } = {}) {
      const thresholds = {
        any: 0,
        all: 1
      }

      if (typeof IntersectionObserver === 'undefined') {
        return () => {}
      }

      let elements
      if (typeof elementOrSelector === 'string') {
        elements = document.querySelectorAll(elementOrSelector)
      } else if (elementOrSelector instanceof Element) {
        elements = [elementOrSelector]
      } else {
        elements = Array.from(elementOrSelector || [])
      }

      const activeIntersections = new WeakMap()
      const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
          const onEnd = activeIntersections.get(entry.target)
          if (entry.isIntersecting === Boolean(onEnd)) return
          if (entry.isIntersecting) {
            const newOnEnd = onStart(entry)
            if (typeof newOnEnd === 'function') {
              activeIntersections.set(entry.target, newOnEnd)
            } else {
              observer.unobserve(entry.target)
            }
          } else if (onEnd) {
            onEnd(entry)
            activeIntersections.delete(entry.target)
          }
        })
      }

      const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === 'number' ? amount : thresholds[amount]
      })

      elements.forEach((element) => observer.observe(element))
      return () => observer.disconnect()
    }
  }

  customElements.define('sticky-scroller', StickyScroller)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.drawer"] && !Shopify.designMode) return;
  try {
    class OverlayDrawer extends HTMLElement {
    constructor() {
      super();
      
      
      
      // Store arrow functions to ensure same reference for add/remove
    }

    connectedCallback() {
      this.closeButton = null;
      this.triggers = null;
      this.previouslyFocused = document.activeElement;
      this.trapFocusHandlers = {};
      this.abortController = new AbortController();
      this.closeButton = this.querySelector('[data-drawer-close-button]');
      this.triggers = document.querySelectorAll(
        `[data-open-drawer="${this.id}"]`
      );

      const signal = this.abortController.signal;
      
      this.moveToBody();

      this.closeButton.addEventListener('click', () => this.close(), { signal });
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        }, { signal });
      });
      document.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      this.addEventListener('click', (event) => this.handleOverlayClick(event), { signal });
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    open() {
      this.previouslyFocused = document.activeElement;
      
      this.setAttribute('open', 'true');
      this.trapFocus(this);
    }

    close() {
      this.setAttribute('open', 'false');
      this.removeTrapFocus(this.previouslyFocused);
    }

    moveToBody() {
      if (this.parentNode === document.body) return;
      
      // Store the original parent and next sibling for potential restoration
      this.originalParent = this.parentNode;
      this.originalNextSibling = this.nextSibling;
      
      // Move the element to the body
      document.body.appendChild(this);
    }

    handleOverlayClick(event) {
      if (event.target === this) this.close();
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.getAttribute('open') === 'true') {
        this.close();
      }
    }

    removeTrapFocus(elementToFocus = null) {
      if (this.trapFocusAbortController) {
        this.trapFocusAbortController.abort();
        this.trapFocusAbortController = null;
      }

      if (elementToFocus) {
        try {
          elementToFocus.focus({ preventScroll: true })
        } catch (e) {
          elementToFocus.focus()
        }
      }
    }

    forceFocus(element, options = {}) {
      let savedTabIndex = element.tabIndex

      element.tabIndex = -1
      element.dataset.tabIndex = savedTabIndex
      element.focus()
      if (typeof options.className !== 'undefined') {
        element.classList.add(options.className)
      }
      element.addEventListener('blur', callback)

      function callback(event) {
        event.target.removeEventListener(event.type, callback)

        element.tabIndex = savedTabIndex
        delete element.dataset.tabIndex
        if (typeof options.className !== 'undefined') {
          element.classList.remove(options.className)
        }
      }
    }

    focusable(container) {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      )
    }

    trapFocus(container, options = {}) {
      let elements = this.focusable(container)
      let elementToFocus = options.elementToFocus || container
      let first = elements[0]
      let last = elements[elements.length - 1]

      this.removeTrapFocus()

      // Create new AbortController for focus trap events
      this.trapFocusAbortController = new AbortController();
      const signal = this.trapFocusAbortController.signal;

      this.trapFocusHandlers.focusin = function (event) {
        if (container !== event.target && !container.contains(event.target)) {
          this.forceFocus(first || container, options)
        }

        if (event.target !== container && event.target !== last && event.target !== first) return
        document.addEventListener('keydown', this.trapFocusHandlers.keydown, { signal })
      }.bind(this)

      this.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', this.trapFocusHandlers.keydown)
      }.bind(this)

      this.trapFocusHandlers.keydown = function (event) {
        if (event.keyCode !== 9) return // If not TAB key

        // On the last focusable element and tab forward, focus the first element.
          if (event.target === last && !event.shiftKey) {
        event.preventDefault()
        this.forceFocus(first || container, options)
      }

        //  On the first focusable element and tab backward, focus the last element.
          if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault()
        this.forceFocus(last || container, options)
      }
      }.bind(this)

      document.addEventListener('focusout', this.trapFocusHandlers.focusout, { signal })
      document.addEventListener('focusin', this.trapFocusHandlers.focusin, { signal })

      this.forceFocus(elementToFocus, options)
    }
  }

  customElements.define('overlay-drawer', OverlayDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.lightbox"] && !Shopify.designMode) return;
  try {
    class OverlayLightbox extends HTMLElement {
    // Static registry to track all lightbox instances
    static registry = new Map();
    // Track which groups have been prefetched
    static prefetchedGroups = new Set();

    constructor() {
      super();
      this.trigger = null;
      this.template = null;
      this.overlay = null;
      this.closeBtn = null;
      this.prevBtn = null;
      this.nextBtn = null;
      this.group = this.dataset.group;
      this.groupItems = [];
      this.currentIndex = 0;

      // Register this instance
      if (this.group) { 
        if (!OverlayLightbox.registry.has(this.group)) {
          OverlayLightbox.registry.set(this.group, []);
        }
        OverlayLightbox.registry.get(this.group).push(this);
      }
    }

    connectedCallback() {
      // Initialize elements when connected to DOM
      this.trigger = this.querySelector('.overlay-lightbox__trigger');
      this.template = this.querySelector('.overlay-lightbox__template');
      this.init();
    }

    init() {
      // Open lightbox on trigger click
      if (this.trigger) {
        this.trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.openLightbox();
        });
      }


      // Handle ESC key globally
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.closeLightbox();
        } else if (this.isOpen() && this.group) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.navigateToPrevious();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.navigateToNext();
          }
        }
      });
    }

    openLightbox() {
      // Create overlay if it doesn't exist
      if (!this.overlay) {
        this.createOverlay();
      }

      this.overlay.classList.add('overlay-lightbox__overlay--open');
      document.body.style.overflow = 'hidden';

      // If this is part of a group, find all group items
      if (this.group) {
        this.findGroupItems();

        // Prefetch images for the group
        this.prefetchGroupImages();

        // Add single-item class if there's only one item in the group
        if (this.groupItems.length <= 1) {
          this.overlay.classList.add('overlay-lightbox__overlay--single-item');
        } else {
          this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        }
      } else {
        // No group, so hide navigation buttons
        this.overlay.classList.add('overlay-lightbox__overlay--single-item');
      }
    }

    createOverlay() {
      // Check if template exists
      if (!this.template) {
        console.error('OverlayLightbox: Template not found');
        return;
      }

      // Clone the template content
      this.overlay = this.template.content.cloneNode(true).querySelector('.overlay-lightbox__overlay');
      
      // Check if overlay was created successfully
      if (!this.overlay) {
        console.error('OverlayLightbox: Overlay element not found in template');
        return;
      }
      
      // Get references to buttons
      this.closeBtn = this.overlay.querySelector('.lightbox-close');
      this.prevBtn = this.overlay.querySelector('.overlay-lightbox__nav--prev');
      this.nextBtn = this.overlay.querySelector('.overlay-lightbox__nav--next');

      // Add event listeners
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeLightbox();
        });
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToPrevious();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToNext();
        });
      }

      // Close lightbox when clicking outside content
      if (this.overlay) {
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay) {
            this.closeLightbox();
          }
        });
      }

      // Append to body
      if (this.overlay) {
        document.body.appendChild(this.overlay);
      }
    }

    closeLightbox() {
      if (this.overlay) {
        this.overlay.classList.remove('overlay-lightbox__overlay--open');
        this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        
        // Remove overlay immediately
        if (this.overlay.parentNode) {
          this.overlay.parentNode.removeChild(this.overlay);
          this.overlay = null;
          this.closeBtn = null;
          this.prevBtn = null;
          this.nextBtn = null;
        }
      }
      
      document.body.style.overflow = '';
    }


    findGroupItems() {
      // Use the static registry to find group items
      this.groupItems = OverlayLightbox.registry.get(this.group) || [];
      this.currentIndex = this.groupItems.indexOf(this);
    }

    navigateToPrevious() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex - 1;
      if (targetIndex < 0) {
        // Loop to last item
        targetIndex = this.groupItems.length - 1;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    navigateToNext() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex + 1;
      if (targetIndex >= this.groupItems.length) {
        // Loop to first item
        targetIndex = 0;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    switchToLightbox(targetLightbox) {
      // Close current lightbox
      this.closeLightbox();
      
      // Open target lightbox immediately
      targetLightbox.openLightbox();
    }

    prefetchGroupImages() {
      // Only prefetch once per group
      if (this.group && !OverlayLightbox.prefetchedGroups.has(this.group)) {
        OverlayLightbox.prefetchedGroups.add(this.group);
        
        this.groupItems.forEach(lightbox => {
          // Find all images in this lightbox's content
          const images = lightbox.querySelectorAll('img');
          images.forEach(img => {
            // Prefetch the largest available image
            this.prefetchLargestImage(img);
          });
        });
      }
    }

    prefetchLargestImage(img) {
      // Try to get the largest image from srcset first
      if (img.srcset) {
        const srcsetUrls = img.srcset.split(',').map(src => src.trim().split(' ')[0]);
        // Find the largest size (highest number in the URL)
        let largestUrl = img.src;
        let largestSize = 0;
        
        srcsetUrls.forEach(url => {
          const size = this.extractImageSize(url);
          if (size > largestSize) {
            largestSize = size;
            largestUrl = url;
          }
        });
        
        this.prefetchImage(largestUrl);
      } else {
        // No srcset, try to get largest size from original URL
        const largestUrl = this.getLargestImageUrl(img.src);
        this.prefetchImage(largestUrl);
      }
    }

    extractImageSize(url) {
      try {
        const urlObj = new URL(url);
        
        // Check for width parameter
        if (urlObj.searchParams.has('width')) {
          return parseInt(urlObj.searchParams.get('width')) || 0;
        }
        
        // Check for underscore format (image_2400x.jpg)
        const pathParts = urlObj.pathname.split('_');
        if (pathParts.length > 1) {
          const sizeMatch = pathParts[pathParts.length - 1].match(/(\d+)x/);
          if (sizeMatch) {
            return parseInt(sizeMatch[1]) || 0;
          }
        }
      } catch (e) {
        // URL parsing failed
      }
      
      return 0;
    }

    getLargestImageUrl(originalUrl) {
      try {
        const url = new URL(originalUrl);
        
        // Handle Shopify image URLs - try to get 2400px version
        if (url.searchParams.has('width')) {
          url.searchParams.set('width', '2400');
          return url.toString();
        } else if (url.pathname.includes('_')) {
          // Handle Shopify's underscore format
          const pathParts = url.pathname.split('_');
          if (pathParts.length > 1) {
            const extension = pathParts[pathParts.length - 1].split('.')[1] || 'jpg';
            const newPath = pathParts.slice(0, -1).join('_') + '_2400x.' + extension;
            url.pathname = newPath;
            return url.toString();
          }
        }
      } catch (e) {
        // If URL parsing fails, return original
      }
      
      return originalUrl;
    }

    prefetchImage(url) {
      const prefetchImg = new Image();
      prefetchImg.src = url;
    }

    isOpen() {
      return this.overlay && this.overlay.classList.contains('overlay-lightbox__overlay--open');
    }

    // Clean up when element is removed
    disconnectedCallback() {
      if (this.group) {
        const groupItems = OverlayLightbox.registry.get(this.group);
        if (groupItems) {
          const index = groupItems.indexOf(this);
          if (index > -1) {
            groupItems.splice(index, 1);
          }
          // Remove empty groups
          if (groupItems.length === 0) {
            OverlayLightbox.registry.delete(this.group);
          }
        }
      }
    }
  }

  // Define the custom element
  customElements.define('overlay-lightbox', OverlayLightbox);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    if (!window.downpayZeroOrderInitialized) {
    window.downpayZeroOrderInitialized = true;

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-downpay-zero-order-button]');
      if (!button || button.disabled) return;

      const form = button.closest('form[action*="/cart/add"]');
      const variantInput = form && form.querySelector('[name="id"]');
      const wrapper = button.closest('[data-downpay-zero-order]');
      const message = wrapper && wrapper.querySelector('[data-downpay-zero-order-message]');
      const label = button.querySelector('[data-downpay-zero-order-label]');
      const nativeButton = form && form.querySelector('[data-add-to-cart]');
      const variantIsEligible = Boolean(
        variantInput &&
        button.dataset.eligibleVariantIds.indexOf(`,${variantInput.value},`) !== -1
      );

      if (!form || !variantInput || !variantInput.value || !variantIsEligible || (nativeButton && nativeButton.disabled)) {
        if (message) message.textContent = button.dataset.unavailableLabel;
        return;
      }

      if (!form.reportValidity()) return;

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (label) label.textContent = button.dataset.loadingLabel;
      if (message) message.textContent = '';

      try {
        const formData = new FormData(form);
        formData.set('id', variantInput.value);
        if (!formData.has('quantity')) formData.set('quantity', '1');
        formData.set('selling_plan', button.dataset.sellingPlanId);

        const response = await fetch(button.dataset.cartAddUrl, {
          method: 'POST',
          headers: {
            'Accept': 'application/json'
          },
          body: formData
        });

        if (!response.ok) throw new Error('cart_add_failed');
        window.location.assign(button.dataset.checkoutUrl);
      } catch (error) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (label) label.textContent = button.dataset.defaultLabel;
        if (message) message.textContent = button.dataset.errorLabel;
      }
    });

    document.addEventListener('variant:change', () => {
      window.requestAnimationFrame(() => {
        document.querySelectorAll('[data-downpay-zero-order-button]').forEach((button) => {
          const form = button.closest('form[action*="/cart/add"]');
          const nativeButton = form && form.querySelector('[data-add-to-cart]');
          const variantInput = form && form.querySelector('[name="id"]');
          const wrapper = button.closest('[data-downpay-zero-order]');
          const message = wrapper && wrapper.querySelector('[data-downpay-zero-order-message]');
          const label = button.querySelector('[data-downpay-zero-order-label]');
          const variantIsEligible = Boolean(
            variantInput &&
            button.dataset.eligibleVariantIds.indexOf(`,${variantInput.value},`) !== -1
          );
          const unavailable = Boolean((nativeButton && nativeButton.disabled) || !variantIsEligible);

          if (!button.hasAttribute('aria-busy')) {
            button.disabled = unavailable;
            if (label) label.textContent = unavailable ? button.dataset.unavailableButtonLabel : button.dataset.defaultLabel;
            if (message) message.textContent = unavailable ? button.dataset.unavailableLabel : '';
          }
        });
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product.hot-reload"] && !Shopify.designMode) return;
  try {
    class ProductHotReload extends HTMLElement {
    constructor() {
      super();
      this.cache = new Map(); // Cache for pre-fetched content
      this.activeRequests = new Map(); // Track active fetch requests
      this.loadingTimeout = null; // Timeout for loading state
      this.supportsViewTransitions = 'startViewTransition' in document;
      
      this.addEventListener('change', (event) => this.onVariantChange(event));
      this.addEventListener('mouseover', (event) => this.onMouseOver(event));
    }

    showLoadingState() {
      // Start loading state (pulse) after 200ms
      this.loadingTimeout = setTimeout(() => {
        this.classList.add('product-hot-reload--loading');
      }, 200);
    }

    hideLoadingState() {
      // Clear the timeout if it hasn't triggered yet
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
      
      // Remove loading animation
      this.classList.remove('product-hot-reload--loading');
    }

    buildRequestUrl(input) {
      const productFormElement = input.closest('form');
      const sectionId = this.dataset.sectionId;
      
      // Get dataset values from the input or selected option
      let newProductUrl, optionValueId;
      
      if (input.type === 'radio') {
        newProductUrl = input.dataset.productUrl;
        optionValueId = input.dataset.optionValueId;
      } else if (input.tagName === 'SELECT') {
        const selectedOption = input.options[input.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl;
        optionValueId = selectedOption.dataset.optionValueId;
      }

      // Get all currently selected values from both radio inputs and select elements
      let selectedOptionValues = [];
      
      // Get values from checked radio inputs
      const checkedRadios = Array.from(productFormElement.querySelectorAll('input[type="radio"]:checked'));
      selectedOptionValues = checkedRadios.map(({ dataset }) => dataset.optionValueId).filter(Boolean);
      
      // Get values from select elements
      const selects = Array.from(productFormElement.querySelectorAll('select'));
      selects.forEach(select => {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption && selectedOption.dataset.optionValueId) {
          selectedOptionValues.push(selectedOption.dataset.optionValueId);
        }
      });

      // If we're building for a hover state, replace the current option's value
      if (input.type === 'radio' && !input.checked) {
        const currentOptionName = input.name;
        // Remove any existing selection for this option
        selectedOptionValues = selectedOptionValues.filter(id => {
          const input = productFormElement.querySelector(`input[data-option-value-id="${id}"]`);
          return input && input.name !== currentOptionName;
        });
        // Add the hovered option value
        selectedOptionValues.push(optionValueId);
      }

      const params = selectedOptionValues.length > 0 ? `&option_values=${selectedOptionValues.join(',')}` : '';
      return `${newProductUrl}?section_id=${sectionId}${params}`;
    }

    onMouseOver(event) {
      const label = event.target.closest('label');
      if (!label) return;

      const input = label.querySelector('input[type="radio"]');
      if (!input) return;

      // Don't pre-fetch if already selected
      if (input.checked) return;

      const requestUrl = this.buildRequestUrl(input);

      // Don't prefetch if we already have cached content or an active request
      if (this.cache.has(requestUrl) || this.activeRequests.has(requestUrl)) return;

      // Pre-fetch the content for this option
      this.fetchContent(requestUrl);
    }

    fetchContent(requestUrl) {
      // Create and store the fetch promise
      const fetchPromise = fetch(requestUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.cache.set(requestUrl, html);
          this.activeRequests.delete(requestUrl);
          return html;
        })
        .catch((error) => {
          this.activeRequests.delete(requestUrl);
          throw error;
        });

      this.activeRequests.set(requestUrl, fetchPromise);
      return fetchPromise;
    }

    async onVariantChange(event) {
      if (!event.target.hasAttribute('data-product-hot-reload-trigger')) return;

      const optionValueElement = event.target;
      const requestUrl = this.buildRequestUrl(optionValueElement);
      const oldProductUrl = this.dataset.productUrl;
      
      // Get new product URL from the input or selected option
      let newProductUrl;
      if (optionValueElement.type === 'radio') {
        newProductUrl = optionValueElement.dataset.productUrl || oldProductUrl;
      } else if (optionValueElement.tagName === 'SELECT') {
        const selectedOption = optionValueElement.options[optionValueElement.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl || oldProductUrl;
      } else {
        newProductUrl = oldProductUrl;
      }

      // Start loading state immediately on change event
      this.showLoadingState();

      let html;

      try {
        // Use cached content if available
        if (this.cache.has(requestUrl)) {
          html = this.cache.get(requestUrl);
        }
        // Wait for active request if one exists
        else if (this.activeRequests.has(requestUrl)) {
          html = await this.activeRequests.get(requestUrl);
        }
        // Make new request if no cache or active request
        else {
          html = await this.fetchContent(requestUrl);
        }

        await this.updateProductWithTransition(html, newProductUrl, event.target.id);
      } catch (error) {
        console.error('Error updating product content:', error);
      } finally {
        // Always hide loading state
        this.hideLoadingState();
      }
    }

    async updateProductWithTransition(html, newProductUrl, targetId) {
      const updatedHtml = html.getElementById(this.id);
      
      if (this.supportsViewTransitions) {
        // Use View Transitions API for smooth transitions
        const transition = document.startViewTransition(() => {
          this.innerHTML = updatedHtml.innerHTML;
          this.dataset.productUrl = updatedHtml.dataset.productUrl;
          this.dataset.variantId = updatedHtml.dataset.variantId;
        });

        // Wait for the transition to complete
        await transition.finished;
      } else {
        // Fallback: Update content immediately without animations
        this.innerHTML = updatedHtml.innerHTML;
        this.dataset.productUrl = updatedHtml.dataset.productUrl;
        this.dataset.variantId = updatedHtml.dataset.variantId;
      }

      // Update URL and history
      let url = new URL(newProductUrl, window.location.origin);

      // Preserve all existing URL parameters from the current page
      const currentUrl = new URL(window.location.href);
      for (const [key, value] of currentUrl.searchParams.entries()) {
        // Don't override the variant parameter we're setting
        if (key !== 'variant') {
          url.searchParams.set(key, value);
        }
      }

      // Add variant param if variantId exists
      url.searchParams.set('variant', this.dataset.variantId);

      // Push new state to browser history
      window.history.pushState({}, '', url.toString());

      // Focus the input for the last clicked option value
      this.querySelector(`#${targetId}`).focus();
    }
  }

  customElements.define('product-hot-reload', ProductHotReload);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.gift-recipient"] && !Shopify.designMode) return;
  try {
    class GiftRecipientForm extends HTMLElement {
    constructor() {
      super()
      this.checkboxInput = this.querySelector('.gift-recipient-form__checkbox input[type="checkbox"]')
      this.emailInput = this.querySelector('.gift-recipient-form__email')
      this.nameInput = this.querySelector('.gift-recipient-form__name')
      this.messageInput = this.querySelector('.gift-recipient-form__message')
      this.dateInput = this.querySelector('.gift-recipient-form__date')
      this.addEventListener('change', () => this.onChange())
      this.recipientFields = this.querySelector('.recipient-fields')

      this.checkboxInput.addEventListener('change', () => {
        event.stopPropagation()
        this.recipientFields.style.display = this.checkboxInput.checked ? 'block' : 'none'
      })
    }

    connectedCallback() {
      this.abortController = new AbortController()

      document.addEventListener('product-form:submit:error', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.displayErrorMessage(event.detail.errorMessage)
        }
      }, { signal: this.abortController.signal })

      document.addEventListener('product-form:submit:success', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.clearInputFields()
          this.clearErrorMessage()
        }
      }, { signal: this.abortController.signal })
    }

    disconnectedCallback() {
      this.abortController.abort()
    }

    onChange() {
      if (!this.checkboxInput.checked) {
        this.clearInputFields()
        this.clearErrorMessage()
      }
    }

    clearInputFields() {
      for (const element of this.querySelectorAll('input')) {
        element.value = ''
      }
    }

    displayErrorMessage(body) {
      this.clearErrorMessage()
      if (body) {
        return Object.entries(body).forEach(([key, value]) => {
          const inputElement = this[`${key}Input`]
          if (!inputElement) {
            return
          }

          inputElement.setAttribute('aria-invalid', true)
        })
      }
    }

    clearErrorMessage() {
      for (const inputElement of this.querySelectorAll('input')) {
        inputElement.setAttribute('aria-invalid', false)
        inputElement.removeAttribute('aria-describedby')
      }
    }
  }

  customElements.define('gift-recipient-form', GiftRecipientForm)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.media-gallery"] && !Shopify.designMode) return;
  try {
    class MediaGalleryElement extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.media-gallery__slide');
      this.thumbs = this.querySelectorAll('.media-gallery__thumb');
      this.prevBtn = this.querySelector('.media-gallery__nav--prev');
      this.nextBtn = this.querySelector('.media-gallery__nav--next');
      this.mainContainer = this.querySelector('.media-gallery__main');
      this.currentIndex = 0;
      this.isAnimating = false;
      this.isNaturalAspectRatio = this.mainContainer?.getAttribute('data-aspect-ratio') === 'initial';

      // Touch/swipe handling
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchEndX = 0;
      this.touchEndY = 0;
      this.minSwipeDistance = 50;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      // Adjust container height for natural aspect ratio
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight(true); // Disable transition for initial setup

        // Set up resize observer for images that might load asynchronously
        this.setupResizeObserver();
      }

      // Add click handlers to thumbnails
      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          const direction = index > this.currentIndex ? 'next' : 'prev';
          this.goToSlide(index, direction);
        });
      });

      // Add click handlers to navigation buttons
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.previousSlide();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.nextSlide();
        });
      }

      // Add keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.previousSlide();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.nextSlide();
        }
      });

      // Make the gallery focusable for keyboard navigation
      this.setAttribute('tabindex', '0');

      // Add touch/swipe handlers
      this.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
      this.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: true });
      this.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: true });

      // Ensure only the initial active slide can play
      this.pauseNonActiveSlides();
      this.autoplayActiveSlideIfEligible();
    }

    goToSlide(index, direction = 'next') {
      if (index < 0 || index >= this.slides.length) return;
      if (index === this.currentIndex) return;
      if (this.isAnimating) return;

      const currentSlide = this.slides[this.currentIndex];
      const targetSlide = this.slides[index];

      // Before animating, pause non-target slides
      this.pauseAllMediaExceptInSlide(targetSlide);

      // Reset all slides
      this.resetSlides();

      // Position slides for animation
      this.positionSlidesForAnimation(currentSlide, targetSlide, direction);

      // Update UI state
      this.updateThumbnails(index);
      this.currentIndex = index;

      // Start animation after positioning is applied
      this.animateSlides(currentSlide, targetSlide, direction);

      // Adjust container height for natural aspect ratio after slide change
      if (this.isNaturalAspectRatio) {
        setTimeout(() => {
          this.adjustContainerHeight();
        }, 50); // Small delay to ensure slide is positioned
      }
    }

    resetSlides() {
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--prev', 'media-gallery__slide--next');
      });
    }

    positionSlidesForAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class from all slides during positioning
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--is-animating');
      });

      if (direction === 'next') {
        // Next: target and others on right, current stays in center
        targetSlide.style.transform = 'translateX(100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(100%)';
          }
        });
      } else {
        // Previous: target and others on left, current stays in center
        targetSlide.style.transform = 'translateX(-100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(-100%)';
          }
        });
      }
    }

    updateThumbnails(activeIndex) {
      this.thumbs[this.currentIndex].classList.remove('media-gallery__thumb--active');
      this.thumbs[activeIndex].classList.add('media-gallery__thumb--active');
    }

    adjustContainerHeight(disableTransition = false) {
      if (!this.isNaturalAspectRatio || !this.mainContainer) return;

      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      // Disable transition if requested (for initial setup)
      if (disableTransition) {
        this.mainContainer.classList.add('media-gallery__main--no-transition');
      }

      // Find the image in the active slide
      const img = activeSlide.querySelector('img');
      if (!img) return;

      // Get the image's natural dimensions
      const imgWidth = img.naturalWidth || img.width;
      const imgHeight = img.naturalHeight || img.height;

      if (imgWidth && imgHeight) {
        // Calculate the aspect ratio
        const aspectRatio = imgWidth / imgHeight;

        // Get the container width
        const containerWidth = this.mainContainer.offsetWidth;

        // Calculate the height based on the aspect ratio
        const calculatedHeight = containerWidth / aspectRatio;

        // Set the container height
        this.mainContainer.style.height = calculatedHeight + 'px';
      } else {
        // Fallback: temporarily make the slide visible to measure its height
        const originalOpacity = activeSlide.style.opacity;
        const originalTransform = activeSlide.style.transform;
        activeSlide.style.opacity = '1';
        activeSlide.style.transform = 'translateX(0)';
        activeSlide.style.position = 'relative';
        activeSlide.style.visibility = 'hidden';

        // Get the natural height of the slide content
        const slideHeight = activeSlide.offsetHeight;

        // Restore original styles
        activeSlide.style.opacity = originalOpacity;
        activeSlide.style.transform = originalTransform;
        activeSlide.style.position = '';
        activeSlide.style.visibility = '';

        // Set the container height to match the slide height
        this.mainContainer.style.height = slideHeight + 'px';
      }

      // Re-enable transition after a brief delay
      if (disableTransition) {
        setTimeout(() => {
          this.mainContainer.classList.remove('media-gallery__main--no-transition');
        }, 10);
      }
    }

    setupResizeObserver() {
      if (!this.isNaturalAspectRatio || !window.ResizeObserver) return;

      this.resizeObserver = new ResizeObserver(() => {
        this.adjustContainerHeight();
      });

      // Observe all images in the slides
      this.slides.forEach(slide => {
        const images = slide.querySelectorAll('img');
        images.forEach(img => {
          this.resizeObserver.observe(img);

          // Also listen for load events to recalculate when image loads
          img.addEventListener('load', () => {
            if (slide.classList.contains('media-gallery__slide--active')) {
              this.adjustContainerHeight();
            }
          });
        });
      });
    }

    animateSlides(currentSlide, targetSlide, direction) {
      // Set animation flag
      this.isAnimating = true;

      // Frame 1: Initial positions are already set (no animation class)

      // Frame 2: Add animation class
      requestAnimationFrame(() => {
        currentSlide.classList.add('media-gallery__slide--is-animating');
        targetSlide.classList.add('media-gallery__slide--is-animating');

        // Frame 3: Trigger animation
        requestAnimationFrame(() => {
          // Animate current slide out
          if (direction === 'next') {
            currentSlide.style.transform = 'translateX(-100%)';
          } else {
            currentSlide.style.transform = 'translateX(100%)';
          }

          // Animate target slide in
          targetSlide.style.transform = 'translateX(0)';
          targetSlide.classList.add('media-gallery__slide--active');

          // Clean up after animation
          this.waitForTransition(currentSlide).then(() => {
            this.positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction);
            this.scrollActiveThumbnailIntoView();
            // Hydrate and autoplay current slide media if eligible and pause others
            this.pauseNonActiveSlides();
            this.autoplayActiveSlideIfEligible();
            // Clear animation flag
            this.isAnimating = false;
          });
        });
      });
    }

    positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class and active class from current slide
      currentSlide.classList.remove('media-gallery__slide--is-animating', 'media-gallery__slide--active');
      targetSlide.classList.remove('media-gallery__slide--is-animating');

      if (direction === 'next') {
        currentSlide.style.transform = 'translateX(100%)';
      } else {
        currentSlide.style.transform = 'translateX(-100%)';
      }

      // Adjust container height for natural aspect ratio after animation
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight();
      }
    }

    scrollActiveThumbnailIntoView() {
      this.thumbs[this.currentIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }

    nextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex, 'next');
    }

    previousSlide() {
      const prevIndex = this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1;
      this.goToSlide(prevIndex, 'prev');
    }

    waitForTransition(element) {
      return new Promise((resolve) => {
        const handleTransitionEnd = (e) => {
          if (e.target === element) {
            element.removeEventListener('transitionend', handleTransitionEnd);
            resolve();
          }
        };
        element.addEventListener('transitionend', handleTransitionEnd);
      });
    }

    handleTouchStart(e) {
      if (this.isAnimating) return;

      const touch = e.touches[0];
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
    }

    handleTouchMove(e) {
      if (this.isAnimating) return;

      const touch = e.touches[0];
      this.touchEndX = touch.clientX;
      this.touchEndY = touch.clientY;
    }

    handleTouchEnd(e) {
      if (this.isAnimating) return;

      const deltaX = this.touchEndX - this.touchStartX;
      const deltaY = this.touchEndY - this.touchStartY;
      const absDeltaX = Math.abs(deltaX);
      const absDeltaY = Math.abs(deltaY);

      // Only trigger swipe if horizontal movement is greater than vertical
      if (absDeltaX > absDeltaY && absDeltaX > this.minSwipeDistance) {
        if (deltaX > 0) {
          // Swipe right - go to previous slide
          this.previousSlide();
        } else {
          // Swipe left - go to next slide
          this.nextSlide();
        }
      }
    }

    // Utilities for media control
    pauseAllMediaExceptInSlide(slide) {
      const allowed = new Set(slide ? Array.from(slide.querySelectorAll('video-media, model-media')) : []);
      this.querySelectorAll('video-media[playing], model-media[playing]').forEach((el) => {
        if (!allowed.has(el)) {
          el.pause();
        }
      });
    }

    pauseNonActiveSlides() {
      this.slides.forEach((slide, index) => {
        if (index !== this.currentIndex) {
          slide.querySelectorAll('video-media[playing], model-media[playing]').forEach((element) => element.pause());
        }
      });
    }

    autoplayActiveSlideIfEligible() {
      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      const mediaEls = activeSlide.querySelectorAll('video-media, model-media');
      mediaEls.forEach((element) => {
        if (!element.hasAttribute('autoplay')) return;
        if (element.hasAttribute('playing')) return;
        // If already loaded, try immediately; else wait for 'loaded' attribute
        if (element.hasAttribute('loaded')) {
          element.play();
        } else {
          const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'loaded' && element.hasAttribute('loaded')) {
                observer.disconnect();
                element.play();
                break;
              }
            }
          });

          observer.observe(element, { attributes: true, attributeFilter: ['loaded'] });
        }
      });
    }
  }

  // Define the custom element
  customElements.define('media-gallery', MediaGalleryElement);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-advisor-script"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  const VERSION = 2;
  const PROFILE_KEY = 'nanostudio.size-advisor.profile.v2';
  const TTL = 180 * 24 * 60 * 60 * 1000;
  const TOP_HEM_RATIO = 0.95;
  const BRAND_WEIGHT = 0.25;
  const BRAND_CATALOG = Object.freeze(Object.fromEntries([
    ['uniqlo-basic-jp-20260909','uniqlo','brand_item_uniqlo_basic',{XS:46,S:49,M:52,L:55,XL:59,XXL:63},'https://utme.uniqlo.com/m/itemlineup/'],
    ['uniqlo-u-jp-20260909','uniqlo','brand_item_uniqlo_u',{S:50,M:53,L:56,XL:60,XXL:64},'https://utme.uniqlo.com/m/itemlineup/'],
    ['uniqlo-airism-jp-20260909','uniqlo','brand_item_uniqlo_airism',{S:52.5,M:55.5,L:58.5,XL:62.5,XXL:66.5},'https://utme.uniqlo.com/m/itemlineup/'],
    ['uniqlo-sweat-jp-20260909','uniqlo','brand_item_uniqlo_sweat',{S:53.5,M:56.5,L:59.5,XL:63.5,XXL:67.5},'https://utme.uniqlo.com/m/itemlineup/'],
    ['zara-1887411060-jp-20260909','zara','brand_item_zara_02',{S:53,M:55,L:57,XL:59,XXL:61},'https://www.zara.com/jp/ja/%E3%83%9F%E3%83%86%E3%82%99%E3%82%A3%E3%82%A2%E3%83%A0%E3%82%A6%E3%82%A7%E3%82%A4%E3%83%88-%E3%83%98%E3%82%99%E3%83%BC%E3%82%B7%E3%83%83%E3%82%AFt%E3%82%B7%E3%83%A3%E3%83%84--02-p01887411.html']
  ].map(([id,brand,label,widths,source])=>[id,Object.freeze({id,brand,label,widths:Object.freeze(widths),source,market:'JP',line:'men-unisex',kind:'tops',basis:'flat-chest-width-cm',verifiedAt:'2026-09-09'})])));
  const BRAND_GUIDES = Object.freeze(Object.fromEntries(['uniqlo','zara'].map(brand=>{
    const items=Object.values(BRAND_CATALOG).filter(item=>item.brand===brand),sizes={};
    for(const size of ['XS','S','M','L','XL','XXL']){
      const widths=items.filter(item=>Object.hasOwn(item.widths,size)).map(item=>item.widths[size]*2);
      if(widths.length)sizes[size]=Object.freeze({min:Math.min(...widths),max:Math.max(...widths),sampleCount:widths.length});
    }
    return [brand,Object.freeze({sizes:Object.freeze(sizes),sources:Object.freeze([...new Set(items.map(item=>item.source))]),verifiedAt:'2026-09-09'})];
  })));
  const MALE_BODY_COEFFICIENTS = Object.freeze({
    chest:Object.freeze([93.15428013994543,0.3104040845143037,1.927612478052224]),
    waist:Object.freeze([78.18390097452553,0.3329416028977472,2.4662527198668664]),
    hip:Object.freeze([90.2299903043147,0.38877676017460777,1.6752136140501792]),
    shoulder:Object.freeze([39.65049877335388,0.147895138013139,0.1909663818124399])
  });
  const CIRC = ['chest', 'waist', 'hip'];
  const LIMITS = {height:[140,210],weight:[35,180],age:[18,90],chest:[55,180],waist:[45,180],hip:[60,200],shoulder:[25,65]};
  const PROFILE_FIELDS = ['height','weight','age','gender','fit','chestShape','waistShape','hipShape','shoulderShape','brand','brandSize'];
  const clamp = (n,a,b) => Math.min(b,Math.max(a,n));
  const round = n => Math.round(n*10)/10;
  const norm = s => String(s ?? '').normalize('NFKC').trim();
  const sizeKey = s => norm(s).toUpperCase().replace(/\s+/g,'').replace(/^XXXXL$/,'4XL').replace(/^XXXL$/,'3XL').replace(/^XXL$/,'2XL');
  const esc = s => String(s ?? '').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const translationText = s => String(s ?? '').replace(/&(amp|lt|gt|quot|apos|#39|#x27);/g,(_,entity)=>({amp:'&',lt:'<',gt:'>',quot:'"',apos:"'",'#39':"'",'#x27':"'"}[entity]));
  const number = v => v === '' || v === null || v === undefined ? null : (Number.isFinite(Number(v)) ? Number(v) : null);
  function object(value) {
    let v = value;
    for(let i=0;i<2&&typeof v==='string';i++){try{v=JSON.parse(v);}catch{return {};}}
    return v && typeof v==='object' && !Array.isArray(v) ? v : {};
  }
  function measurement(value,multiplier=1,key='',explicit=false) {
    if(value===null||value===undefined||value==='')return null;
    let lo,hi;
    if(typeof value==='object'&&!Array.isArray(value)){lo=number(value.min ?? value.value);hi=number(value.max ?? value.value ?? value.min);}
    else {
      const text=norm(value).toLowerCase().replace(/\s/g,'').replace(/cm$|センチ$/,'').replace(/,(?=\d{1,2}(?:[~〜～–—-]|$))/g,'.');
      const match=text.match(/^(\d+(?:\.\d+)?)(?:[~〜～–—-](\d+(?:\.\d+)?))?$/);
      if(!match)return null;
      lo=Number(match[1]);hi=Number(match[2] ?? match[1]);
    }
    if(lo===null||hi===null||lo<=0||hi<lo)return null;
    lo=round(lo*multiplier);hi=round(hi*multiplier);
    if(hi>300)return null;
    if(CIRC.includes(key)&&!explicit&&lo<({chest:70,waist:60,hip:70}[key]))return null;
    return {min:lo,max:hi};
  }
  function header(value,kind) {
    const h=norm(value).toLowerCase().replace(/[\s_-]/g,'');
    if(/inch|インチ|英寸|인치|\bmm\b/.test(h))return null;
    let key=null;
    if(/股下|inseam|안쪽다리|binnenbeenlengte/.test(h))key='inseam';
    else if(/股上|rise|太もも|わたり|thigh|밑위|허벅지|kruishoogte|dijbeen/.test(h))return null;
    else if(/肩幅|肩宽|肩寬|shoulder|어깨|schouderbreedte/.test(h))key='shoulder';
    else if(/袖丈|袖长|袖長|sleeve|소매|mouwlengte/.test(h))key='sleeve';
    else if(/身幅|胸囲|胸围|胸圍|胸宽|胸寬|バスト|bust|chest|pittopit|armpittoarmpit|가슴|borst(?:omvang|omtrek|breedte)/.test(h))key='chest';
    else if(/ウエスト|腰围|腰圍|waist|허리|taille(?:omvang|omtrek|breedte)/.test(h))key='waist';
    else if(/ヒップ|臀围|臀圍|hip|엉덩이|힙|heup(?:omvang|omtrek|breedte)/.test(h))key='hip';
    else if(/裾口|裾幅|裾周り|裾まわり|hem|legopening|밑단|zoom(?:opening|wijdte|breedte|omtrek)|pijp(?:opening|breedte)/.test(h))key='hem';
    else if(/パンツ丈|裤长|褲長|outseam|바지길이|broeklengte|buitenbeenlengte/.test(h))key='outseam';
    else if(/着丈|総丈|衣长|衣長|^length(?:\(cm\))?$|bodylength|총장|기장|(?:kleding|totale|rug|rok)lengte/.test(h))key=kind==='bottoms'||kind==='skirt'?'outseam':'length';
    if(!key)return null;
    const flat=/身幅|胸宽|胸寬|平置き|平量|平铺|平鋪|flat|width|pittopit|armpittoarmpit|half|1\/2|半囲|半圍|半围|단면|breedte|platgemeten/.test(h);
    const circumference=/一周|周長|周长|周り|まわり|circumference|전체둘레|한바퀴|omvang|omtrek/.test(h);
    const basis=key==='hem'?(flat||/裾幅/.test(h)?'flat':circumference?'round':'unspecified'):CIRC.includes(key)&&flat?'flat':null;
    return {key,multiplier:CIRC.includes(key)&&flat?2:1,explicit:flat||circumference,...(basis?{basis}:{}),...(flat&&circumference?{ambiguous:true}:{})};
  }
  function kindOf(config,chart) {
    const text=norm((config.type??'')+' '+(config.title??'')).toLowerCase();
    if(/バッグ|かばん|bag\b|シューズ|スニーカー|靴|shoes?|sneaker|帽子|\bhat\b|サングラス|glasses|ネックレス|necklace/.test(text))return 'unsupported';
    const classify=value=>{
      const t=norm(value).toLowerCase();
      if(/ジャンプスーツ|jumpsuit|ワンピース|원피스|連身裙|连衣裙|\bdress\b(?![\s-]*shirts?\b)/.test(t))return 'dress';
      if(/スカート|\bskirt\b|스커트|半身裙/.test(t))return 'skirt';
      if(/セット|setup|\bset\b|[&+]|\band\b/.test(t)&&/パンツ|\b(pants|sweatpants|trousers|jeans|shorts)\b|바지|팬츠|褲|裤/.test(t))return 'bottoms';
      if(/ジャケット|コート|シャツ|ニット|セーター|パーカー|ベスト|カーディガン|トップス|\b(jacket|coat|shirts?|tops?|knit|sweater|hoodie|vest|cardigan|blazer|pullover|polo)\b|재킷|자켓|코트|셔츠|니트|상의|外套|襯衫|衬衫|上衣/.test(t))return 'tops';
      if(/パンツ|トラウザー|\b(pants|sweatpants|trousers|jeans|shorts|joggers|leggings)\b|바지|팬츠|褲|裤/.test(t))return 'bottoms';
      return null;
    };
    const named=classify(config.title)??classify(config.type);if(named)return named;
    const keys=Object.values(chart).flatMap(v=>Object.keys(object(v))).join(' ');
    if(/bust|chest|shoulder|sleeve/.test(keys))return 'tops';
    if(/hip|waist|inseam/.test(keys))return 'bottoms';
    if(/デニム|\bdenim\b/.test(text))return 'bottoms';
    return 'tops';
  }
  const sameMeasurement=(a,b)=>Boolean(a&&b&&Math.abs(a.min-b.min)<=.5&&Math.abs(a.max-b.max)<=.5);
  function tableChart(tables,sizes,kind,verified={}) {
    const result={},claimed={},rejected={};let uncertain=false,conflict=false;
    const reject=(size,key)=>{(rejected[size]??=new Set()).add(key);if(result[size])delete result[size][key];uncertain=true;};
    for(let rows of tables){
      if(rows.slice(0,3).flat().some(c=>/インチ|inches|\binch\b|英寸|인치|\bmm\b|毫米|밀리미터/i.test(c)))continue;
      if(rows[0]?.slice(1).filter(c=>sizes.some(s=>sizeKey(s)===sizeKey(c))).length>=2&&rows.slice(1).some(r=>header(r[0],kind))&&rows.every(r=>r.length===rows[0].length))rows=rows[0].map((_,i)=>rows.map(r=>r[i]));
      const hi=rows.findIndex(row=>row.map(c=>header(c,kind)).filter(Boolean).length>=1);
      if(hi<0)continue;
      const heads=rows[hi].map(c=>header(c,kind));
      const sizeColumn=rows[hi].findIndex(c=>/^(size|サイズ|尺码|尺寸|사이즈|maat|maten)(?:\s*\(cm\))?$/i.test(norm(c)));
      for(const row of rows.slice(hi+1)){
        if(row.length!==heads.length)continue;
        const index=sizeColumn>=0?sizeColumn:0,size=sizes.find(s=>sizeKey(s)===sizeKey(row[index]));
        if(!size)continue;
        for(let j=0;j<heads.length;j++){
          if(j===index)continue;
          const h=heads[j];if(!h)continue;
          (claimed[size]??=new Set()).add(h.key);
          let m=h.ambiguous?null:measurement(row[j],h.multiplier,h.key,h.explicit),basis=h.basis;
          const known=verified[size]?.[h.key];
          if(!h.ambiguous&&!h.explicit&&CIRC.includes(h.key)&&known?.basis==='flat'){
            const doubled=measurement(row[j],2,h.key,true);
            if(sameMeasurement(doubled,known)){m=doubled;basis='flat';}
          }
          if(!m){reject(size,h.key);continue;}
          const prev=result[size]?.[h.key];
          if(prev&&!sameMeasurement(prev,m)){reject(size,h.key);conflict=true;continue;}
          if(!rejected[size]?.has(h.key))(result[size]??={})[h.key]={...m,source:'description',...(basis?{basis}:{})};
        }
      }
    }
    return {chart:result,uncertain,conflict,claimed,rejected};
  }
  function normalize(config,tables=[]) {
    const outer=object(config.chart),raw=object(outer.sizeChart ?? outer.size_chart ?? outer);
    const kind=kindOf(config,raw),variants=Array.isArray(config.variants)?config.variants:[],options=config.options??[];
    let sizeIndex=options.findIndex(x=>/^(size|サイズ|尺码|尺寸|사이즈|maat|maten)$/i.test(norm(typeof x==='object'?x.name:x)));
    if(sizeIndex<0){
      let best=0;
      options.forEach((_,i)=>{const hits=variants.filter(v=>Object.keys(raw).some(k=>sizeKey(k)===sizeKey(v.options?.[i]))).length;if(hits>best){best=hits;sizeIndex=i;}});
    }
    let sizes=sizeIndex>=0?[...new Set(variants.map(v=>v.options?.[sizeIndex]).filter(Boolean))]:Object.keys(raw).filter(k=>/^(\d*X*[SML]|\d{1,3}|FREE|ONE\s?SIZE|F)$/i.test(k));
    const chart={},conflictingRows=new Set();let uncertain=false,conflict=false;
    for(const size of sizes){
      const row=object(raw[Object.keys(raw).find(k=>sizeKey(k)===sizeKey(size))]);
      chart[size]={};const rejected=new Set();
      for(const [k,value] of Object.entries(row)){
        const h=header(k,kind);if(!h)continue;
        const m=h.ambiguous?null:measurement(value,h.multiplier,h.key,h.explicit),prev=chart[size][h.key];
        if(prev&&m&&!sameMeasurement(prev,m)){rejected.add(h.key);delete chart[size][h.key];conflict=true;}
        if(m&&!rejected.has(h.key))chart[size][h.key]={...m,source:'metafield',...(h.basis?{basis:h.basis}:prev?.basis==='flat'?{basis:'flat'}:{})};else uncertain=true;
      }
    }
    const fromTable=tableChart(tables,sizes,kind,chart);
    for(const [size,keys] of Object.entries(fromTable.claimed)){
      const row=fromTable.chart[size]??{};
      const mismatch=[...keys].some(key=>chart[size]?.[key]&&!sameMeasurement(chart[size][key],row[key]));
      if(mismatch){conflict=true;conflictingRows.add(size);chart[size]={};}
      for(const key of keys){if(row[key])chart[size][key]=row[key];else delete chart[size][key];}
    }
    const heightsRaw=object(config.heights),fallback=object(outer.recommendedHeights ?? outer.recommended_heights),heights={};
    for(const s of sizes){
      const source=Object.keys(heightsRaw).length?heightsRaw:fallback;
      const h=object(source[Object.keys(source).find(k=>sizeKey(k)===sizeKey(s))]);
      const low=number(h.min_height ?? h.min),high=number(h.max_height ?? h.max);
      if(!conflictingRows.has(s)&&low!==null&&high!==null&&low>=100&&high<=240&&low<=high)heights[s]={min:low,max:high};
    }
    return {kind,chart,sizes,variants,sizeIndex,heights,uncertain:uncertain||fromTable.uncertain,conflict:conflict||fromTable.conflict,
      supported:kind!=='unsupported'&&sizes.some(s=>Object.keys(chart[s]??{}).length||heights[s])};
  }
  function cleanProfile(value) {
    const source=object(value),profile={height:'',weight:'',age:'',gender:'',fit:'regular'};
    for(const key of PROFILE_FIELDS)if(Object.hasOwn(source,key))profile[key]=source[key];
    if(!Object.hasOwn(BRAND_GUIDES,profile.brand??'')){delete profile.brand;delete profile.brandSize;}
    else if(!Object.hasOwn(BRAND_GUIDES[profile.brand].sizes,profile.brandSize??''))delete profile.brandSize;
    return profile;
  }
  function brandReference(data,p,body) {
    const profile=cleanProfile(p);if(!profile.brand)return null;
    const range=BRAND_GUIDES[profile.brand].sizes[profile.brandSize];
    const reference={brand:profile.brand,size:range?profile.brandSize:null};
    if(data.kind!=='tops')return {...reference,status:'unsupported'};
    if(!range)return {...reference,status:'incomplete'};
    if(!data.sizes.some(s=>data.chart[s]?.chest))return {...reference,status:'missing'};
    const chest={min:range.min,max:range.max};
    if(chest.max<body.chest.value)return {...reference,chest,status:'conflict'};
    return {...reference,chest,status:'applied'};
  }
  function withBrandReference(result,data,p) {
    const brand=brandReference(data,p,result.body);if(!brand)return result;
    if(brand.status!=='applied')return {...result,brand};
    const viable=result.rows.filter(row=>row.usable&&!row.tooSmall&&row.metrics.chest);
    if(!viable.length)return {...result,brand:{...brand,status:'no_viable'}};
    const score=row=>(1-BRAND_WEIGHT)*row.score+BRAND_WEIGHT*Math.max(brand.chest.min-row.dims.chest.min,row.dims.chest.min-brand.chest.max,0)/6;
    const ranked=viable.slice().sort((a,b)=>score(a)-score(b));
    return {...result,best:ranked[0],brand};
  }
  function profileErrors(p) {
    const errors=[];
    for(const k of ['height','weight','age']){
      const n=number(p[k]);
      if(k==='age'&&n===null&&(p[k]===''||p[k]===null||p[k]===undefined))continue;
      if(n===null||n<LIMITS[k][0]||n>LIMITS[k][1]||(k==='age'&&!Number.isInteger(n)))errors.push(k);
    }
    if(!['male','female','neutral'].includes(p.gender))errors.push('gender');
    if(!['close','regular','relaxed'].includes(p.fit??'regular'))errors.push('fit');
    for(const k of ['chestShape','waistShape','hipShape','shoulderShape']){
      const v=p[k];if(v===undefined)continue;
      const n=number(v);if(n===null||![-1,0,1].includes(n))errors.push(k);
    }
    return errors;
  }
  function estimate(p) {
    if(profileErrors(p).length)return null;
    const h=Number(p.height),bmi=Number(p.weight)/((h/100)**2),female=p.gender==='female';
    let base;
    if(p.gender==='male'){
      base=Object.fromEntries(Object.entries(MALE_BODY_COEFFICIENTS).map(([key,[a,b,c]])=>[key,a+b*(h-170)+c*(bmi-22)]));
    }else{
      const age=number(p.age),ageAdjust=age===null?0:clamp((age-40)*.08,0,3);
      base={
        chest:h*(female?.50:.51)+(bmi-22)*1.5,
        waist:h*(female?.40:.415)+(bmi-22)*2.2+ageAdjust,
        hip:h*(female?.56:.55)+(bmi-22)*1.3,
        shoulder:h*(female?.22:.23)+(bmi-22)*.12
      };
    }
    const out={};
    for(const [k,v] of Object.entries(base)){
      const shape=clamp(number(p[k+'Shape'])??0,-1,1),adjust=k==='shoulder'?1.5:k==='waist'?6:4;
      out[k]={value:round(clamp(v+shape*adjust,LIMITS[k][0],LIMITS[k][1])),source:'estimated'};
    }
    return out;
  }
  function fitLabel(ease,key) {
    if(ease<0)return 'too_small';
    const levels=key==='waist'?[1,4,8]:key==='shoulder'?[1,3,6]:key==='hip'?[4,10,18]:[6,16,26];
    if(ease<levels[0])return 'snug';if(ease<=levels[1])return 'balanced';if(ease<=levels[2])return 'loose';return 'extra_loose';
  }
  function assess(data,p) {
    const body=estimate(p);if(!body)return null;
    const keys=(data.kind==='bottoms'||data.kind==='skirt'?['waist','hip']:data.kind==='dress'?['chest','waist','hip']:['chest','shoulder']).filter(key=>key!=='waist'||p.gender!=='male');
    const targets={chest:{close:6,regular:12,relaxed:20},hip:{close:4,regular:8,relaxed:14},waist:{close:1,regular:3,relaxed:5},shoulder:{close:0,regular:2,relaxed:4}};
    const rows=data.sizes.map(size=>{
      const dims=data.chart[size]??{},metrics={};let score=0,total=0,tooSmall=false;
      for(const key of keys){
        const dim=dims[key];if(!dim)continue;
        const ease=round(dim.min-body[key].value),maxEase=round(dim.max-body[key].value);
        metrics[key]={ease,maxEase,label:fitLabel(ease,key),body:body[key],garment:dim};
        const weight=key==='shoulder'?.15:key==='waist'?.7:1;
        score+=Math.abs(ease-targets[key][p.fit??'regular'])/6*weight;total+=weight;
        if(maxEase<0&&key!=='shoulder'){tooSmall=true;score+=10+Math.abs(maxEase);}
      }
      const hr=data.heights[size];
      if(hr){const distance=Math.max(hr.min-Number(p.height),Number(p.height)-hr.max,0);score+=distance/4;total+=.4;}
      return {size,dims,metrics,tooSmall,usable:total>0,score:total?score/total:Infinity,height:hr};
    });
    const hasBodyData=rows.some(r=>Object.keys(r.metrics).some(k=>k!=='shoulder'));
    const viable=rows.filter(r=>r.usable&&!r.tooSmall&&(!hasBodyData||Object.keys(r.metrics).some(k=>k!=='shoulder'))).sort((a,b)=>a.score-b.score);
    const best=viable[0]??null;
    return withBrandReference({body,rows,best,keys},data,p);
  }
  function bodyGeometry(p,body=estimate(p)) {
    if(!body)return null;
    const bodyHeight=370,inseamRatio=.45,scale=bodyHeight/Number(p.height);
    const y={top:20,shoulder:90,chest:125,foot:390};
    y.crotch=y.foot-bodyHeight*inseamRatio;
    y.waist=y.crotch-60;y.hip=y.crotch-24;y.ankle=y.foot-12;
    const legLength=y.ankle-y.crotch;
    y.thigh=y.crotch+legLength*.095;y.knee=y.crotch+legLength*.48;y.calf=y.crotch+legLength*.69;
    const project=(circ,factor=1)=>clamp(circ/(2*Math.PI)*scale*factor,4,76);
    const leg={thigh:body.hip.value*.55,knee:body.hip.value*.34,calf:body.hip.value*.36,ankle:body.hip.value*.225};
    const front={chest:project(body.chest.value,1.08),waist:project(body.waist.value,1.08),hip:project(body.hip.value,1.08),shoulder:clamp(body.shoulder.value*scale/2,25,64)};
    const side={chest:project(body.chest.value,.78),waist:project(body.waist.value,.78),hip:project(body.hip.value,.78)};
    for(const [k,circ] of Object.entries(leg)){front[k]=project(circ);side[k]=project(circ,.88);}
    front.stance=front.hip*.55;
    return {scale,inseamRatio,y,front,side};
  }
  function pantsGeometry(data,row,p,body=bodyGeometry(p)) {
    const d=row.dims;
    if(!body||!d.hip)return null;
    const {scale,y}=body,project=circ=>clamp(circ/(2*Math.PI)*scale*1.08,5,76);
    const hip=project(d.hip.min),waistSource=d.waist?'product':'schematic';
    const waist=d.waist?project(d.waist.min):Math.min(body.front.waist+2,hip*.94);
    let hem,hemSource='schematic';
    if(d.hem?.basis==='flat'||d.hem?.basis==='round'){
      hem=project(d.hem.min*(d.hem.basis==='flat'?2:1));hemSource='product';
    }else if(d.hem){
      const refs=data.sizes.map(s=>data.chart[s]).filter(r=>r?.hip&&r?.hem&&(r.hem.basis??'unspecified')==='unspecified');
      const base=refs.reduce((a,r)=>!a||r.hem.min<a.hem.min?r:a,null);
      if(base){hem=project(base.hip.min)*.40*d.hem.min/base.hem.min;hemSource='relative';}
    }
    hem=clamp(hem??hip*.40,5,48);
    const thigh=hip*.50,knee=thigh*.45+hem*.55;
    const front={waist,hip,thigh,knee,hem,stance:hip*.55};
    const side={waist:waist*.78/1.08,hip:hip*.78/1.08,thigh:thigh*.90,knee:knee*.84,hem:hem*.82};
    const bottom=clamp(d.outseam?y.waist+d.outseam.min*scale:d.inseam?y.crotch+d.inseam.min*scale:y.ankle+6,y.hip+18,402);
    return {front,side,waistSource,hemSource,lengthSource:d.outseam?'outseam':d.inseam?'inseam':'schematic',y:{top:y.waist,hip:Math.min(y.hip,bottom-20),crotch:Math.min(y.crotch,bottom-12),thigh:Math.min(y.thigh,bottom-9),knee:Math.min(y.knee,bottom-5),bottom}};
  }
  function variantFor(data,size,selected) {
    if(data.sizeIndex<0||selected.length===0)return null;
    return data.variants.find(v=>v.options?.every((value,i)=>i===data.sizeIndex?sizeKey(value)===sizeKey(size):value===selected[i]))??null;
  }
  function unpackSaved(raw,now=Date.now()) {
    try{const o=JSON.parse(raw);if(o.version!==VERSION||!Number.isFinite(o.updatedAt)||now-o.updatedAt>TTL||o.updatedAt>now+60000)return null;return o.data;}catch{return null;}
  }
  const Core={normalize,tableChart,measurement,header,cleanProfile,profileErrors,estimate,assess,bodyGeometry,pantsGeometry,variantFor,unpackSaved,sizeKey,brandReference,brandCatalog:BRAND_CATALOG,brandGuides:BRAND_GUIDES,brandWeight:BRAND_WEIGHT,maleBodyCoefficients:MALE_BODY_COEFFICIENTS};
  if(typeof module==='object'&&module.exports)module.exports=Core;
  if(typeof window==='undefined'||!window.customElements)return;
  if(customElements.get('nano-size-advisor'))return;
  let serial=0;
  class NanoSizeAdvisor extends HTMLElement {
    connectedCallback() {
      if(this.ready)return;
      this.ready=true;
      try{
        this.config=JSON.parse(this.dataset.config);
        this.initializeLanguages();
        const parsed=new DOMParser().parseFromString(this.config.description??'','text/html');
        const tables=[...parsed.querySelectorAll('table')].map(t=>[...t.rows].map(r=>[...r.cells].map(c=>c.textContent.trim())));
        this.data=normalize(this.config,tables);
        if(!this.data.supported)return;
        this.uid='nsa-'+(++serial);
        this.profile={height:'',weight:'',age:'',gender:'',fit:'regular'};
        this.remember=false;this.storageProblem=false;this.step=0;this.view='front';
        this.readSaved();
        this.launch=this.querySelector('[data-nsa-open]');this.launch.hidden=false;
        this.launch.addEventListener('click',()=>this.open());
        this.updateLauncher();
      }catch{this.ready=false;}
    }
    disconnectedCallback(){if(this.dialog?.open)this.dialog.close();}
    languageKey(value){
      const code=String(value??'').replace(/_/g,'-').toLowerCase(),base=code.split('-')[0];
      if(base==='zh')return 'zh-TW';
      return ['ja','en','ko','es','de','fr','th','id','it','nl'].includes(base)?base:null;
    }
    initializeLanguages(){
      this.languages=this.config.languages??{};
      this.pageLanguage=this.languageKey(this.config.locale);
      this.language=this.languages[this.pageLanguage]?this.pageLanguage:this.languages.en?'en':this.pageLanguage;
    }
    t(key){
      const labels=this.language===this.pageLanguage?this.config.i18n:this.languages?.[this.language]?.strings;
      return translationText(labels?.[key]??this.languages?.[this.language]?.strings?.[key]??this.config.i18n?.[key]??key);
    }
    text(key){return esc(this.t(key));}
    languagePicker(){
      const items=Object.entries(this.languages??{});
      if(items.length<2)return '';
      return `<select class="nsa-language" data-nsa-language aria-label="${this.text('language')}">${items.map(([code,pack])=>`<option value="${esc(code)}" lang="${esc(code)}" ${this.language===code?'selected':''}>${esc(pack.name)}</option>`).join('')}</select>`;
    }
    renderHeader(){
      this.dialog.lang=this.language??this.config.locale??'en';
      this.dialog.querySelector('.nsa-head').innerHTML=`<div class="nsa-head-title"><div class="nsa-brand">NANOSTUDIO · SIZE GUIDE</div><h2 id="${this.uid}-title">${this.text('title')}</h2></div><div class="nsa-head-actions">${this.languagePicker()}<button type="button" class="nsa-icon-button" data-action="close" aria-label="${this.text('close')}">×</button></div>`;
    }
    changeLanguage(code){
      if(!Object.prototype.hasOwnProperty.call(this.languages??{},code)||code===this.language)return;
      this.captureInputs();
      const body=this.dialog.querySelector('.nsa-body'),scroll=body.scrollTop;
      const error=this.dialog.querySelector('[data-error]'),invalid=[...this.dialog.querySelectorAll('[aria-invalid="true"][data-profile]')].map(el=>el.dataset.profile);
      const keepError=error&&!error.hidden;
      this.language=code;this.renderHeader();this.render();this.updateLauncher();
      if(keepError){const next=this.dialog.querySelector('[data-error]');if(next){next.hidden=false;next.textContent=this.t('basic_error');}invalid.forEach(key=>this.dialog.querySelector(`[data-profile="${key}"]`)?.setAttribute('aria-invalid','true'));}
      body.scrollTop=scroll;this.dialog.querySelector('[data-status]').textContent='';
      this.dialog.querySelector('[data-nsa-language]')?.focus({preventScroll:true});
    }
    readSaved(){
      try{
        const p=cleanProfile(unpackSaved(localStorage.getItem(PROFILE_KEY)));
        if(p&&profileErrors(p).length===0){this.profile=p;this.remember=true;}
      }catch{this.storageProblem=true;}
    }
    persist(){
      try{
        if(this.remember){
          localStorage.setItem(PROFILE_KEY,JSON.stringify({version:VERSION,updatedAt:Date.now(),data:cleanProfile(this.profile)}));
        }else{localStorage.removeItem(PROFILE_KEY);}
        this.storageProblem=false;
      }catch{this.storageProblem=true;}
    }
    updateLauncher(){
      const title=this.querySelector('[data-nsa-open] strong');if(title)title.textContent=this.t('title');
      if(this.launch)this.launch.lang=this.language??this.config.locale??'en';
      const summary=this.querySelector('[data-nsa-summary]');
      if(this.result?.best)summary.textContent=this.t('reference')+' '+this.result.best.size+' · '+this.profile.height+' cm / '+this.profile.weight+' kg';
      else summary.textContent=this.remember?this.t('saved_summary'):this.t('launch_hint');
    }
    open(){
      if(!this.dialog){
        this.dialog=document.createElement('dialog');this.dialog.className='nsa-dialog';
        this.dialog.setAttribute('aria-labelledby',this.uid+'-title');
        this.dialog.innerHTML='<header class="nsa-head"></header><div class="nsa-body"></div><div class="nsa-screen-reader" role="status" aria-live="polite" data-status></div>';
        this.append(this.dialog);
        this.dialog.addEventListener('click',e=>this.onClick(e));
        this.dialog.addEventListener('change',e=>this.onChange(e));
        this.dialog.addEventListener('input',e=>this.onInput(e));
        this.dialog.addEventListener('keydown',e=>this.onKey(e));
        this.dialog.addEventListener('close',()=>{if(this.previousOverflow!==undefined){document.body.style.overflow=this.previousOverflow;this.previousOverflow=undefined;}this.launch.focus();});
        this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}});
      }
      if(this.remember&&!this.result){this.result=assess(this.data,this.profile);this.selected=this.result?.best?.size??this.data.sizes[0];this.step=2;}
      this.renderHeader();this.render();this.dialog.querySelector('.nsa-body').scrollTop=0;
      this.previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';
      this.dialog.showModal();this.focusHeading();
    }
    announce(key){const el=this.dialog.querySelector('[data-status]');el.textContent=this.t(key);}
    focusHeading(){const heading=this.dialog.querySelector('.nsa-body h3');if(heading){heading.tabIndex=-1;heading.focus({preventScroll:true});}}
    selectedOptions(){
      const root=this.closest('[data-product-id]');if(!root)return [];
      return this.config.options.map((_,i)=>{
        const inputs=[...root.querySelectorAll(`[data-variant-input][data-index="option${i+1}"]`)];
        return inputs.find(el=>el.tagName==='SELECT'||el.checked)?.value??null;
      });
    }
    currentVariant(){return variantFor(this.data,this.selected,this.selectedOptions());}
    applySize(){
      const variant=this.currentVariant(),root=this.closest('[data-product-id]');
      if(!variant?.available||!root){this.announce('apply_error');return;}
      const inputs=[...root.querySelectorAll(`[data-variant-input][data-index="option${this.data.sizeIndex+1}"]`)];
      const input=inputs.find(el=>el.type==='radio'&&sizeKey(el.value)===sizeKey(this.selected))??inputs.find(el=>el.tagName==='SELECT');
      if(!input){this.announce('apply_error');return;}
      if(input.tagName==='SELECT')input.value=variant.options[this.data.sizeIndex];else input.checked=true;
      input.dispatchEvent(new Event('change',{bubbles:true}));
      const actual=this.selectedOptions();
      if(actual.every((v,i)=>v===variant.options[i])){this.dialog.close();this.updateLauncher();this.launch.querySelector('small').textContent=this.t('applied');}
      else this.announce('apply_error');
    }
    onInput(e){
      const key=e.target.dataset.profile;if(PROFILE_FIELDS.includes(key))this.profile[key]=e.target.value;
    }
    captureInputs(){
      this.dialog.querySelectorAll('[data-profile]').forEach(el=>{if(el.type!=='radio'||el.checked)this.onInput({target:el});});
    }
    onChange(e){
      if(e.target.dataset.nsaLanguage!==undefined){this.changeLanguage(e.target.value);return;}
      this.onInput(e);
      if(e.target.dataset.profile==='gender')this.profile.gender=e.target.value;
      const key=e.target.dataset.profile;
      if(key==='brand'){
        delete this.profile.brandItem;
        delete this.profile.brandSize;
        this.dialog.querySelector('[data-brand-fields]').innerHTML=this.brandFields();
        this.dialog.querySelector(`[data-profile="${key}"]`)?.focus({preventScroll:true});
      }
      if(e.target.dataset.remember!==undefined){this.remember=e.target.checked;if(!this.remember)this.persist();}
    }
    onKey(e){
      if(e.key==='Enter'&&e.target.tagName==='INPUT'&&e.target.type==='number'&&this.step<2){e.preventDefault();this.advance();}
    }
    onClick(e){
      const target=e.target.closest('button');if(!target||!this.dialog.contains(target))return;
      this.captureInputs();
      if(target.dataset.size){this.selected=target.dataset.size;this.renderResults();this.dialog.querySelector(`[data-size="${CSS.escape(this.selected)}"]`)?.focus();return;}
      if(target.dataset.view){this.view=target.dataset.view;this.renderResults();this.dialog.querySelector(`[data-view="${this.view}"]`)?.focus();return;}
      const action=target.dataset.action;
      if(action==='close')this.dialog.close();
      if(action==='next')this.advance();
      if(action==='back'){this.step=Math.max(0,this.step-1);this.render();this.focusHeading();}
      if(action==='edit'){this.step=0;this.render();this.focusHeading();}
      if(action==='apply')this.applySize();
      if(action==='reset'){
        this.remember=false;this.persist();this.profile=cleanProfile({});this.result=null;this.step=0;
        this.updateLauncher();this.render();this.announce(this.storageProblem?'storage_error':'reset_done');this.focusHeading();
      }
    }
    showError(keys,message){
      this.dialog.querySelectorAll('[aria-invalid]').forEach(el=>el.removeAttribute('aria-invalid'));
      const error=this.dialog.querySelector('[data-error]');error.hidden=false;error.textContent=this.t(message);
      keys.forEach(k=>this.dialog.querySelector(`[data-profile="${k}"]`)?.setAttribute('aria-invalid','true'));
      this.dialog.querySelector(`[data-profile="${keys[0]}"]`)?.focus();
    }
    advance(){
      this.captureInputs();
      const errors=profileErrors(this.profile);
      if(errors.length){this.showError(errors,'basic_error');return;}
      if(this.step===0){this.step=1;this.render();this.focusHeading();return;}
      this.result=assess(this.data,this.profile);this.selected=this.result.best?.size??this.data.sizes[0];this.step=2;
      this.persist();this.updateLauncher();this.render();this.dialog.querySelector('.nsa-body').scrollTop=0;this.focusHeading();this.announce('profile_ready');
    }
    render(){
      if(this.step===2){this.renderResults();return;}
      this.dialog.querySelector('.nsa-body').innerHTML=`${this.progress()}<section class="nsa-step">${this.step===0?this.basics():this.shape()}<p class="nsa-error" data-error role="alert" hidden></p><div class="nsa-actions">${this.step===0?`<button type="button" class="nsa-link" data-action="reset">${this.text('reset')}</button>`:`<button type="button" class="nsa-secondary" data-action="back">${this.text('back')}</button>`}<button type="button" class="nsa-primary" data-action="next">${this.text(this.step===0?'next':'check')}</button></div></section>`;
      this.dialog.querySelector('.nsa-body').scrollTop=0;
    }
    progress(){return `<ol class="nsa-progress" aria-label="${this.text('title')}">${['basics','shape','result'].map((k,i)=>`<li ${i===this.step?'aria-current="step"':''} class="${i<this.step?'is-done':''}">${i+1}. ${this.text(k)}</li>`).join('')}</ol>`;}
    field(key){
      const value=this.profile[key]??'',limits=LIMITS[key];
      return `<label class="nsa-field"><span>${this.text(key)}</span><input type="number" inputmode="decimal" data-profile="${key}" value="${esc(value)}" min="${limits[0]}" max="${limits[1]}" step="${key==='age'?'1':'0.1'}" autocomplete="off" placeholder="${limits[0]}–${limits[1]}" ${key==='height'||key==='weight'?'required':''}></label>`;
    }
    choices(key,items,legend){return `<fieldset class="nsa-fieldset"><legend>${this.text(legend)}</legend><div class="nsa-choices">${items.map(([v,label])=>`<label class="nsa-choice"><input type="radio" name="${this.uid}-${key}" data-profile="${key}" value="${v}" ${String(this.profile[key]??(key.endsWith('Shape')?0:''))===String(v)?'checked':''}><span>${this.text(label)}</span></label>`).join('')}</div></fieldset>`;}
    basics(){return `<h3>${this.text('profile_title')}</h3><p class="nsa-subtitle">${this.text('profile_hint')}</p>${this.choices('gender',[['male','male'],['female','female'],['neutral','neutral']],'gender')}<div class="nsa-grid">${this.field('height')}${this.field('weight')}${this.field('age')}</div>${this.brandInput()}<label class="nsa-check"><input type="checkbox" data-remember ${this.remember?'checked':''}><span>${this.text('remember')}<br><small>${this.text('remember_note')}</small></span></label><div class="nsa-note">${this.text('privacy')}</div>${this.storageProblem?`<p class="nsa-note">${this.text('storage_error')}</p>`:''}`;}
    brandFields(){
      const p=cleanProfile(this.profile),guide=BRAND_GUIDES[p.brand];
      const select=(key,label,empty,options,disabled=false)=>`<label class="nsa-field"><span>${this.text(label)}</span><select data-profile="${key}" ${disabled?'disabled':''}><option value="">${this.text(empty)}</option>${options.map(([value,text])=>`<option value="${esc(value)}" ${p[key]===value?'selected':''}>${esc(text)}</option>`).join('')}</select></label>`;
      return `${select('brand','brand_label','brand_none',[['uniqlo',this.t('brand_uniqlo')],['zara',this.t('brand_zara')]])}${guide?`${select('brandSize','brand_size','brand_choose_size',Object.keys(guide.sizes).map(s=>[s,s]))}<p class="nsa-disclaimer">${guide.sources.map(source=>`<a href="${esc(source)}" target="_blank" rel="noopener noreferrer">${this.text('brand_source')}</a>`).join(' · ')} · ${this.text('brand_checked')} ${guide.verifiedAt}</p>`:''}`;
    }
    brandInput(){
      if(this.data.kind!=='tops')return this.profile.brand?`<p class="nsa-note">${this.text('brand_unsupported')}</p>`:'';
      return `<details class="nsa-brand-reference" open><summary>${this.text('brand_title')}</summary><p>${this.text('brand_hint')}</p><p class="nsa-disclaimer">${this.text('brand_scope')}</p><div data-brand-fields>${this.brandFields()}</div></details>`;
    }
    brandSummary(){
      const brand=this.result.brand;if(!brand)return '';
      return `<div class="nsa-note nsa-brand-result" data-brand-status="${brand.status}"><strong>${this.text('brand_result')} ${this.text('brand_'+brand.brand)}${brand.size?' · '+esc(brand.size):''}</strong><p>${this.text('brand_'+brand.status)}</p>${brand.status==='applied'?`<p>${this.text('brand_note')}</p>`:''}</div>`;
    }
    shape(){
      const parts=this.data.kind==='bottoms'||this.data.kind==='skirt'?['waist','hip']:this.data.kind==='dress'?['chest','waist','hip','shoulder']:['chest','shoulder'];
      const keys=parts.filter(k=>this.data.sizes.some(s=>this.data.chart[s]?.[k]));
      return `<h3>${this.text('shape_title')}</h3><p class="nsa-subtitle">${this.text('shape_hint')}</p>${this.choices('fit',[['close','close_fit'],['regular','regular_fit'],['relaxed','relaxed_fit']],'fit')}${keys.map(k=>`<div class="nsa-shape-row"><span>${this.text('body_'+k)}</span>${this.choices(k+'Shape',[[-1,'narrow'],[0,'average'],[1,'wide']],'body_'+k)}</div>`).join('')}`;
    }
    dim(m){return m?`${m.min}${m.max!==m.min?'–'+m.max:''}`:'—';}
    signed(n){return (n>0?'+':'')+n;}
    sizes(){return `<div class="nsa-sizes" aria-label="${this.text('size')}">${this.data.sizes.map(s=>`<button type="button" data-size="${esc(s)}" aria-pressed="${s===this.selected}">${esc(s)}${s===this.result.best?.size?`<small>${this.text('best_marker')}</small>`:''}</button>`).join('')}</div>`;}
    row(){return this.result.rows.find(r=>r.size===this.selected);}
    renderResults(){
      const body=this.dialog.querySelector('.nsa-body'),scroll=body.scrollTop;
      body.innerHTML=`${this.progress()}<section class="nsa-results"><div class="nsa-result-top"><div><span class="nsa-kicker">${this.text('result')} · ${esc(this.profile.height)} cm / ${esc(this.profile.weight)} kg</span><h3>${this.text('results_title')}</h3><p class="nsa-product-name">${esc(this.config.title)}</p></div><button type="button" class="nsa-secondary" data-action="edit">${this.text('edit')}</button></div>${this.fitPanel()}${this.storageProblem?`<p class="nsa-note" role="status">${this.text('storage_error')}</p>`:''}${this.profile.gender==='male'?`<p class="nsa-disclaimer" data-body-model="ansur-ii-male-20260909">${this.text('male_model_note')}</p>`:''}<p class="nsa-disclaimer">${this.text('fit_note')}</p><button type="button" class="nsa-link" data-action="reset">${this.text('reset')}</button></section>`;
      body.scrollTop=scroll;
    }
    summary(){
      const best=this.result.best;
      if(!best)return `<div class="nsa-note"><strong>${this.text(this.result.rows.some(r=>r.usable)?'no_recommend':'unsupported')}</strong><p>${this.text(this.result.rows.some(r=>r.usable)?'no_recommend_note':'no_match')}</p></div>${this.brandSummary()}`;
      return `<div class="nsa-summary"><strong>${esc(best.size)}</strong><div><p>${this.text('reference')}</p>${Object.keys(best.metrics).length===0?`<p>${this.text('height_only')}</p>`:''}</div></div>${this.brandSummary()}`;
    }
    metric(key,row){
      const m=row.metrics[key];
      if(!m)return '';
      const pct=clamp((m.ease/(key==='waist'?14:key==='shoulder'?10:30))*100,0,100);
      return `<div class="nsa-metric"><div><dt>${this.text(key)}</dt><dd>${this.text(m.label)}${m.ease>=0?' · '+this.signed(m.ease)+' cm':''}</dd></div><small>${this.text('garment')} ${this.dim(m.garment)} cm − ${this.text(m.body.source)} ${m.body.value} cm</small>${m.garment.basis==='flat'?`<small data-flat-width>${this.text('flat_width')} ${this.dim({min:round(m.garment.min/2),max:round(m.garment.max/2)})} cm × 2</small>`:''}${m.garment.min!==m.garment.max?`<small>${this.text('range_note')}</small>`:''}${key==='shoulder'?`<small>${this.text('drop_shoulder')}</small>`:''}<div class="nsa-meter" aria-hidden="true"><i style="left:${pct}%"></i></div><div class="nsa-meter-labels" aria-hidden="true"><span>${this.text('snug')}</span><span>${this.text('loose')}</span></div></div>`;
    }
    canDiagram(row){return Boolean(row?.dims?.[this.data.kind==='bottoms'||this.data.kind==='skirt'?'hip':'chest']);}
    armDrawingGeometry(shape,view){
      const side=view==='side',width=side?clamp(shape.side.chest*.25,4.5,9):clamp(shape.front.chest*.20,5,10);
      const handScale=clamp((width+(side?5:4))/11,.8,1.12),halfWrist=(side?3.3:4)*handScale;
      return {width,handScale,halfWrist,shoulderY:side?97:89,wristY:side?208:204,wristX:side?174:shape.front.shoulder+width*.55+7,padding:clamp(width*.20,1.4,2.2)};
    }
    frontArmPose(shape,sign){return `rotate(${-70*sign} ${160+sign*shape.front.shoulder} 89)`;}
    sleeveDrawing(row,shape,view=this.view){
      const measured=row.dims.sleeve?.min;
      if(measured!==undefined){const length=clamp(measured*shape.scale*.75,26,115);return {source:'garment',style:'measured',length,end:view==='front'?90+length:clamp(100+measured*shape.scale*.65,127,213)};}
      const classify=value=>{
        const text=norm(value).toLowerCase();
        if(/ノースリーブ|袖なし|無袖|无袖|민소매|소매\s*없|\b(sleeveless|vest|gilet|tank\s*top)\b|ベスト|ジレ|背心|조끼/.test(text))return 'none';
        if(/半袖|短袖|반팔|\b(short|half)[\s-]*sleeve/.test(text))return 'short';
        if(/長袖|长袖|긴팔|롱\s*슬리브|\blong[\s-]*sleeve/.test(text))return 'long';
        if(/ジャケット|ブルゾン|コート|パーカー|スウェット|カーディガン|セーター|\b(jacket|coat|blazer|bomber|parka|hoodie|sweatshirt|cardigan|sweater)\b|夹克|夾克|外套|大衣|재킷|자켓|코트|후드|가디건|스웨터/.test(text))return 'long';
        if(/t[\s-]*shirts?|\btee\b|tシャツ|t恤|티셔츠/.test(text))return 'short';
        return null;
      };
      const style=classify(this.config.title)??classify(this.config.type);
      if(style==='none')return {source:'category',style,length:0,end:90};
      const arm=this.armDrawingGeometry(shape,view),end=style==='short'?arm.shoulderY+(arm.wristY-arm.shoulderY)*.36:arm.wristY-7;
      return {source:style?'category':'generic',style:style??'unknown',length:end-90,end,arm};
    }
    fittedSleeve(shape,s,view,sign=1){
      const a=s.arm,w=a.width,p=a.padding,end=s.end,short=s.style==='short',lerp=(from,to,t)=>from+(to-from)*t;
      const meta=` data-sleeve-source="${s.source}" data-sleeve-style="${s.style}" data-sleeve-fit="mannequin" data-cuff-y="${end}" data-body-wrist-y="${a.wristY}"`;
      if(view==='front'){
        const x=n=>160+sign*(shape.front.shoulder+n),wrist=w*.55+7;
        const t=short?(-14+Math.sqrt(196+200*(end-89)))/100:1;
        const outer=short?-2*(1-t)**2+2*(w+4)*(1-t)*t+(w+6)*t*t:lerp(w+6,wrist+a.halfWrist,(end-153)/51);
        const inner=short?lerp(-w,2,(end-111)/44):lerp(2,wrist-a.halfWrist,(end-155)/49);
        const outerPath=short?`Q${x(lerp(-2,w+4,t)+p)} ${lerp(89,96,t)} ${x(outer+p)} ${end}`:`Q${x(w+4+p)} 94 ${x(w+6+p)} 153 L${x(outer+p)} ${end}`;
        const innerPath=short?'':` L${x(2-p)} 155`;
        return `<path data-part="front-${sign<0?'right':'left'}-sleeve"${meta} d="M${x(-2)} 87 ${outerPath} L${x(inner-p)} ${end}${innerPath} L${x(-w-p)} 111 Q${x(-w-p)} 96 ${x(-2)} 87 Z"/><path data-part="front-${sign<0?'right':'left'}-cuff" d="M${x(inner-p+.5)} ${end-4} L${x(outer+p-.5)} ${end-4}" fill="none" opacity=".55"/>`;
      }
      const outer=short?lerp(156+w,162+w,(end-103)/48):lerp(162+w,a.wristX+a.halfWrist,(end-151)/57);
      const inner=short?lerp(149-w,162-w,(end-120)/37):lerp(162-w,a.wristX-a.halfWrist,(end-157)/51);
      const outerPath=short?'':` L${162+w+p} 151`,innerPath=short?'':` L${162-w-p} 157`;
      return `<path data-part="profile-sleeve"${meta} d="M${156-w-p} 95 Q158 90 ${156+w+p} 102${outerPath} L${outer+p} ${end} L${inner-p} ${end}${innerPath} L${149-w-p} 120 Q${147-w-p} 103 ${156-w-p} 95 Z"/><path data-part="profile-cuff" d="M${inner-p+.5} ${end-4} L${outer+p-.5} ${end-4}" fill="none" opacity=".55"/>`;
    }
    visualFitNeeded(row){
      if(!this.canDiagram(row))return false;
      const shape=bodyGeometry(this.profile,this.result.body);
      return this.data.kind==='bottoms'||this.data.kind==='skirt'?this.pantsDrawingGeometry(row,shape).adjusted===true:['front','side'].some(view=>this.topDrawingGeometry(row,shape,view).adjusted);
    }
    topDrawingGeometry(row,shape,view){
      const {scale,y}=shape,d=row.dims,side=view==='side',b=shape[view],hemRatio=this.data.kind==='tops'?TOP_HEM_RATIO:1;
      const bottom=clamp(85+(d.length?.min??65)*scale,side?161:160,side?384:390);
      const rawWidth=side?clamp(d.chest.min/(2*Math.PI)*scale*.78,17,48):d.chest.min/(2*Math.PI)*scale*1.08;
      const rawShoulder=(d.shoulder?.min??this.result.body.shoulder.value)/2*scale;
      let width=rawWidth,shoulder=rawShoulder;
      {
        const padding=1.2;
        if(side){
          const back=Math.max(b.chest*.72,b.waist*.75,bottom>y.waist?b.hip*.95:0,bottom>y.hip?b.thigh+5:0)+padding;
          const front=Math.max(b.chest*.82,b.waist*.82,bottom>y.waist?b.hip*.85:0,bottom>y.hip?b.thigh+4:0)+padding;
          width=Math.max(width,back/(.72-.77*(1-hemRatio)),front/(.82-.77*(1-hemRatio)));
        }else{
          const radius=Math.max(b.chest,b.waist,bottom>y.waist?b.hip:0,bottom>y.hip?b.stance+b.thigh:0)+padding;
          width=Math.max(width,radius/hemRatio);
          shoulder=Math.max(shoulder,b.shoulder+2.4);
        }
      }
      return {width,shoulder,bottom,hemRatio,adjusted:width>rawWidth+.001||shoulder>rawShoulder+.001};
    }
    pantsDrawingGeometry(row,shape){
      const original=pantsGeometry(this.data,row,this.profile,shape);
      if(!original)return null;
      const g={...original,front:{...original.front},side:{...original.side}},padding=1.2;
      for(const view of ['front','side']){
        const f=g[view],b=shape[view];
        f.waist=Math.max(f.waist,b.waist+padding);f.hip=Math.max(f.hip,b.hip+padding);
        f.thigh=Math.max(f.thigh,b.thigh+padding);
        f.knee=Math.max(f.knee,b.knee+2,b.calf+3);
        f.hem=Math.max(f.hem,g.y.bottom<shape.y.knee?b.thigh+padding:g.y.bottom<shape.y.calf?b.calf+padding:b.ankle+3);
      }
      const keys=this.data.kind==='skirt'?['waist','hip']:['waist','hip','thigh','knee','hem'];
      g.adjusted=['front','side'].some(view=>keys.some(key=>g[view][key]>original[view][key]+.001));
      if(!g.adjusted)return original;
      g.front.stance=shape.front.stance;
      return g;
    }
    unavailablePreview(){return `<div class="nsa-preview-empty" data-preview-unavailable role="status"><strong>${this.text('preview_unavailable')}</strong><p>${this.text(this.data.kind==='bottoms'||this.data.kind==='skirt'?'preview_needs_hip':'preview_needs_chest')}</p><p>${this.text('preview_unavailable_note')}</p></div>`;}
    fitPanel(){
      const row=this.row(),variant=this.currentVariant(),lengths=['outseam','length','inseam','sleeve'].filter(k=>row.dims[k]),canPreview=this.canDiagram(row);
      const preview=canPreview?`<div class="nsa-visual-head"><div><h4>${this.text('diagram')}</h4><p>${this.text('viewing')} ${esc(this.selected)}</p></div><div class="nsa-view-tabs">${['front','side'].map(v=>`<button type="button" data-view="${v}" aria-pressed="${this.view===v}">${this.text(v)}</button>`).join('')}</div></div>${this.diagram(row)}`:this.unavailablePreview();
      return `<div class="nsa-result-grid"><div class="nsa-visual">${preview}</div><div>${this.summary()}${this.sizes()}<span class="nsa-kicker">${this.text('viewing')} ${esc(this.selected)} · ${this.text('ease')}</span><dl class="nsa-metrics">${this.result.keys.map(k=>this.metric(k,row)).join('')}${lengths.map(k=>`<div class="nsa-metric"><div><dt>${this.text(k)}</dt><dd>${this.dim(row.dims[k])} cm</dd></div><small>${this.text(canPreview?'length_note':'garment')}</small></div>`).join('')}</dl>${row.height?`<p class="nsa-disclaimer">${this.text('height_guide')} ${this.dim(row.height)} cm</p>`:''}<p class="nsa-stock">${this.text(variant?variant.available?'in_stock':'sold_out':'choose_options')}</p><button type="button" class="nsa-primary nsa-select-size" data-action="apply" ${variant?.available?'':'disabled'}>${this.text('apply')}</button></div></div>${this.data.uncertain||this.data.conflict?`<p class="nsa-note">${this.text('data_note')}</p>`:''}`;
    }
    diagram(row){
      if(!this.canDiagram(row))return this.unavailablePreview();
      const shape=bodyGeometry(this.profile,this.result.body);
      if(this.view==='side')return this.diagramFrame(this.sideDiagram(row,shape),shape,row);
      const {front:b,y,scale}=shape,d=row.dims;
      const leg=sign=>{
        const x=n=>160+sign*(b.stance+n);
        return `<path data-part="front-${sign<0?'left':'right'}-leg" d="M${x(b.thigh)} ${y.crotch-8} L${x(b.thigh)} ${y.thigh} Q${x(b.knee)} ${(y.thigh+y.knee)/2} ${x(b.knee)} ${y.knee} Q${x(b.calf)} ${y.calf-10} ${x(b.calf*.92)} ${y.calf+9} L${x(b.ankle)} ${y.ankle} L${x(b.ankle+3)} ${y.foot-5} Q${x(b.ankle+4)} ${y.foot} ${x(-b.ankle)} ${y.foot} L${x(-b.ankle)} ${y.ankle} Q${x(-b.calf*.78)} ${y.calf+8} ${x(-b.knee)} ${y.knee} L${x(-b.thigh)} ${y.thigh-4} Z"/>`;
      };
      const arm=sign=>{
        const x=n=>160+sign*(b.shoulder+n),{width:w,handScale,halfWrist,shoulderY,wristY}=this.armDrawingGeometry(shape,'front'),wrist=x(w*.55+7);
        return `<g data-part="front-${sign<0?'right':'left'}-arm-pose" transform="${this.frontArmPose(shape,sign)}"><path data-part="front-${sign<0?'right':'left'}-arm" d="M${x(-2)} ${shoulderY} Q${x(w+4)} 96 ${x(w+6)} 153 L${wrist+sign*halfWrist} ${wristY} L${wrist-sign*halfWrist} ${wristY} L${x(2)} 155 L${x(-w)} 111 Z"/>${this.handDetails(wrist,wristY-2,handScale,sign,sign>0,'front')}</g>`;
      };
      const body=`${leg(-1)}${leg(1)}<path data-part="front-torso" d="M151 65 L151 78 Q${160-b.shoulder+8} 83 ${160-b.shoulder} ${y.shoulder} L${160-b.chest} ${y.chest} Q${160-b.waist} ${y.waist-20} ${160-b.waist} ${y.waist} Q${160-b.hip} ${(y.waist+y.hip)/2} ${160-b.hip} ${y.hip} L${160-b.stance-b.thigh} ${y.crotch+4} Q145 ${y.crotch+12} 160 ${y.crotch} Q175 ${y.crotch+12} ${160+b.stance+b.thigh} ${y.crotch+4} L${160+b.hip} ${y.hip} Q${160+b.hip} ${(y.waist+y.hip)/2} ${160+b.waist} ${y.waist} Q${160+b.waist} ${y.waist-20} ${160+b.chest} ${y.chest} L${160+b.shoulder} ${y.shoulder} Q${160+b.shoulder-8} 83 169 78 L169 65 Z"/><ellipse cx="160" cy="43" rx="17" ry="23"/>${arm(-1)}${arm(1)}`;
      let garment='';
      if((this.data.kind==='bottoms'||this.data.kind==='skirt')&&d.hip){
        const g=this.pantsDrawingGeometry(row,shape),f=g.front,v=g.y;
        if(this.data.kind==='skirt'){
          garment=`<path d="M${160-f.waist} ${v.top} L${160+f.waist} ${v.top} Q${160+f.hip} ${v.hip} ${160+f.hip+10} ${v.bottom} L${160-f.hip-10} ${v.bottom} Q${160-f.hip} ${v.hip} ${160-f.waist} ${v.top} Z"/>`;
        }else{
          garment=`<path data-part="front-trousers" data-waist-source="${g.waistSource}" data-hem-source="${g.hemSource}" d="M${160-f.waist} ${v.top} L${160+f.waist} ${v.top} Q${160+f.hip} ${v.top+13} ${160+f.hip} ${v.hip} L${160+f.stance+f.thigh} ${v.thigh} Q${160+f.stance+f.knee} ${v.knee} ${160+f.stance+f.hem} ${v.bottom} L${160+f.stance-f.hem} ${v.bottom} Q${160+f.stance-f.knee} ${v.knee} ${160+f.stance-f.thigh} ${v.thigh} Q162 ${v.crotch} 160 ${v.crotch} Q158 ${v.crotch} ${160-f.stance+f.thigh} ${v.thigh} Q${160-f.stance+f.knee} ${v.knee} ${160-f.stance+f.hem} ${v.bottom} L${160-f.stance-f.hem} ${v.bottom} Q${160-f.stance-f.knee} ${v.knee} ${160-f.stance-f.thigh} ${v.thigh} L${160-f.hip} ${v.hip} Q${160-f.hip} ${v.top+13} ${160-f.waist} ${v.top} Z"/><path data-part="front-leg-seams" d="M${160-f.hip*.56} ${v.hip+6} Q${160-f.stance} ${v.knee} ${160-f.stance} ${v.bottom-4} M${160+f.hip*.56} ${v.hip+6} Q${160+f.stance} ${v.knee} ${160+f.stance} ${v.bottom-4}" fill="none" opacity=".35"/>`;
        }
        garment+=`<path data-part="front-waistband" data-measurement-source="${g.waistSource}" d="M${160-f.waist-1} ${v.top+7} Q160 ${v.top+10} ${160+f.waist+1} ${v.top+7}" fill="none"/>`;
      }else if((this.data.kind==='tops'||this.data.kind==='dress')&&d.chest){
        const {width:w,shoulder:sw,bottom,hemRatio}=this.topDrawingGeometry(row,shape,'front'),s=this.sleeveDrawing(row,shape,'front'),hem=w*hemRatio;
        const sleeveMeta=` data-sleeve-source="${s.source}" data-sleeve-style="${s.style}"`;
        const sleeves=s.style==='none'?'':[-1,1].map(sign=>{
          const x=n=>160+sign*(b.shoulder+n),a=this.armDrawingGeometry(shape,'front'),end=s.end;
          // A measured sleeve retains its measured drawing length. Only missing lengths follow the wrist.
          const measured=`<path data-part="front-${sign<0?'right':'left'}-sleeve"${sleeveMeta} data-cuff-y="${end}" d="M${x(-2)} 87 Q${x(a.width+7)} 93 ${x(a.width+9)} 109 L${x(a.width+12)} ${end} L${x(2-a.halfWrist)} ${end} L${x(-a.width-3)} 111 Q${x(-a.width-3)} 96 ${x(-2)} 87 Z"/><path data-part="front-${sign<0?'right':'left'}-cuff" d="M${x(3-a.halfWrist)} ${end-4} L${x(a.width+11)} ${end-4}" fill="none" opacity=".55"/>`;
          return `<g data-part="front-${sign<0?'right':'left'}-sleeve-pose" transform="${this.frontArmPose(shape,sign)}">${s.arm?this.fittedSleeve(shape,s,'front',sign):measured}</g>`;
        }).join('');
        const underarms=s.style==='none'?'':[-1,1].map(sign=>{
          const a=this.armDrawingGeometry(shape,'front'),end=s.end,lerp=(from,to,t)=>from+(to-from)*t;
          const inner=s.arm?(s.style==='short'?lerp(-a.width,2,(end-111)/44):lerp(2,a.width*.55+7-a.halfWrist,(end-155)/49))-a.padding:2-a.halfWrist;
          const angle=-70*sign*Math.PI/180,dx=sign*inner,dy=end-89;
          const cuffX=160+sign*b.shoulder+dx*Math.cos(angle)-dy*Math.sin(angle),cuffY=89+dx*Math.sin(angle)+dy*Math.cos(angle);
          // Join the sleeve to the underarm in the raised pose; avoid detached shoulder-pad shapes.
          return `<path data-part="front-${sign<0?'right':'left'}-underarm-fill" d="M${160+sign*sw} 90 L${cuffX} ${cuffY} L${160+sign*w} 129 Z" stroke="none"/><path data-part="front-${sign<0?'right':'left'}-underarm" d="M${cuffX} ${cuffY} L${160+sign*w} 129" fill="none"/>`;
        }).join('');
        garment=`${sleeves}${underarms}<path data-part="front-top" data-hem-source="schematic" data-hem-ratio="${hemRatio}"${sleeveMeta} d="M148 78 Q160 92 172 78 L${160+sw} 90 L${160+w} 129 L${160+hem} ${bottom} L${160-hem} ${bottom} L${160-w} 129 L${160-sw} 90 Z"/><path data-part="front-hem-seam" d="M${160-hem+4} ${bottom-5} H${160+hem-4}" fill="none" stroke-dasharray="3 3" stroke-width=".65" opacity=".65"/>`;
      }
      return this.diagramFrame(`<g data-part="mannequin" fill="#fcfcfd" stroke="#d7d8de" stroke-width=".9">${body}</g><g data-part="garment" fill="#e9eaed" opacity=".78" stroke="#303640" stroke-width="1.35">${garment}</g>`,shape,row);
    }
    handDetails(x,y,scale,mirror,withWatch,view){
      const profile=view==='side',width=profile?.78:1;
      const hand=`<path data-part="${view}-hand-outline" d="M-4 0 L4 0 Q5 4 5 9 L6 20 Q6 22 4.5 22 Q3.5 22 3.2 20 L3.6 24 Q3.6 26 2 26 Q.7 26 .5 24 L.4 26 Q.4 28 -1.2 28 Q-2.7 28 -2.7 26 L-3 25 Q-3 27 -4.6 26.5 Q-6 26 -6 24 L-6.5 12 L-9 16 Q-10.5 17 -11 15.5 Q-11.4 14.7 -10.6 13 L-7 4 Q-6 1 -4 0 Z"/><path data-part="${view}-finger-lines" d="M3.1 13 L3.2 20 M.1 14 L.5 24 M-3.2 14 L-2.7 25 M-6.5 12 Q-5.5 9 -4.3 8" fill="none" stroke-width=".7"/>`;
      const watch=withWatch?`<g data-part="${view}-wristwatch" data-wrist="left" stroke="#7b7e86" stroke-width=".75"><rect x="-5.4" y="-3.7" width="10.8" height="6.6" rx="1.5" fill="#9a9da5"/><rect x="-4.8" y="-5.2" width="9.6" height="10.2" rx="2.4" fill="#d9dbe0"/><rect x="-3.2" y="-3.7" width="6.4" height="7.2" rx="1.5" fill="#646872"/><path d="M0 -2.7 V-.2 L2 1.1" fill="none" stroke="#fff" stroke-width=".8"/><path d="M4.8 -1 H5.9 V1 H4.8" fill="#bec1c8"/></g>`:'';
      return `<g data-part="${view}-hand" aria-hidden="true" transform="translate(${x} ${y}) rotate(${profile?-12:0}) scale(${mirror*width*scale} ${scale})" stroke-linecap="round" stroke-linejoin="round">${hand}${watch}</g>`;
    }
    sideDiagram(row,shape=bodyGeometry(this.profile,this.result.body)){
      if(!this.canDiagram(row))return '';
      const {side:b,y,scale}=shape,d=row.dims;
      const cb=160-b.chest*.72,cf=160+b.chest*.82,wb=160-b.waist*.75,wf=160+b.waist*.82,hb=160-b.hip*.95,hf=160+b.hip*.85;
      const head=`<path data-part="profile-head" d="M146 66 C136 60 132 45 136 32 C139 19 155 15 168 22 Q179 28 177 42 L185 51 Q188 55 178 56 L177 63 Q176 70 165 68 L163 81 L147 81 Z"/><path d="M158 43 Q153 39 153 47 Q154 53 158 49" fill="none" opacity=".7"/>`;
      const leg=(axis,far)=>`<path data-part="${far?'far':'near'}-leg" ${far?'fill="#f1f2f4"':''} d="M${axis-b.thigh} ${y.crotch-11} L${axis+b.thigh} ${y.crotch-11} L${axis+b.thigh} ${y.thigh-2} Q${axis+b.knee+2} ${(y.thigh+y.knee)/2} ${axis+b.knee+2} ${y.knee} Q${axis+b.calf} ${y.calf-6} ${axis+b.ankle+2} ${y.ankle} L${axis+b.ankle+19} ${y.foot-5} Q${axis+b.ankle+24} ${y.foot} ${axis+b.ankle+16} ${y.foot} L${axis-b.ankle} ${y.foot} Q${axis-b.ankle-2} ${y.foot-2} ${axis-b.ankle} ${y.ankle} Q${axis-b.calf} ${y.calf-2} ${axis-b.knee} ${y.knee} L${axis-b.thigh} ${y.thigh-2} Z"/>`;
      const torso=`<path data-part="profile-torso" d="M147 78 L163 79 Q${cf} 92 ${cf} ${y.chest} C${cf} ${y.chest+10} ${wf} ${y.waist-20} ${wf} ${y.waist} Q${hf} ${(y.waist+y.hip)/2} ${hf} ${y.hip} L${164+b.thigh} ${y.crotch-2} Q160 ${y.crotch+9} ${155-b.thigh} ${y.crotch-2} Q${hb} ${y.hip+10} ${hb} ${y.hip} C${hb} ${(y.waist+y.hip)/2} ${wb} ${y.waist+17} ${wb} ${y.waist} Q${cb} ${y.waist-12} ${cb} ${y.chest-1} Q${cb} 91 147 78 Z"/>`;
      const {width:armWidth,handScale,halfWrist,shoulderY,wristY,wristX}=this.armDrawingGeometry(shape,'side');
      const arm=`<path data-part="profile-arm" d="M${156-armWidth} ${shoulderY} Q158 92 ${156+armWidth} 103 L${162+armWidth} 151 L${wristX+halfWrist} ${wristY} L${wristX-halfWrist} ${wristY} L${162-armWidth} 157 L${149-armWidth} 120 Q${147-armWidth} 104 ${156-armWidth} ${shoulderY} Z"/>${this.handDetails(wristX,wristY-2,handScale,-1,true,'side')}`;
      let garment='',sleeve='';
      if((this.data.kind==='bottoms'||this.data.kind==='skirt')&&d.hip){
        const g=this.pantsDrawingGeometry(row,shape),f=g.side,v=g.y;
        const back=160-f.waist*.75,front=160+f.waist*.82,hipBack=160-f.hip*.95,hipFront=160+f.hip*.85;
        if(this.data.kind==='skirt'){
          garment=`<path data-part="profile-skirt" d="M${back} ${v.top} L${front} ${v.top} Q${hipFront} ${v.hip} ${hipFront+8} ${v.bottom} L${hipBack-8} ${v.bottom} Q${hipBack} ${v.hip} ${back} ${v.top} Z"/>`;
        }else{
          const trouser=(axis,far)=>{
            const hem=v.bottom-(far?2:0);
            return `<path data-part="profile-${far?'far':'near'}-trouser" data-waist-source="${g.waistSource}" data-hem-source="${g.hemSource}" ${far?'fill="#dfe1e5"':''} d="M${back} ${v.top} L${front} ${v.top} Q${hipFront} ${v.top+15} ${hipFront} ${v.hip} Q${axis+f.thigh} ${v.crotch} ${axis+f.thigh} ${v.thigh} Q${axis+f.knee} ${v.knee} ${axis+f.hem} ${hem} L${axis-f.hem} ${hem} Q${axis-f.knee} ${v.knee} ${axis-f.thigh} ${v.thigh} Q${hipBack} ${v.crotch} ${hipBack} ${v.hip} Q${hipBack} ${v.top+16} ${back} ${v.top} Z"/>`;
          };
          garment=trouser(155,true)+trouser(164,false);
          garment+=`<path data-part="profile-seam" d="M162 ${v.top+9} Q164 ${v.hip} 164 ${v.thigh} Q164 ${v.knee} 164 ${v.bottom-4}" fill="none" opacity=".4"/>`;
        }
        garment+=`<path data-part="profile-waistband" data-measurement-source="${g.waistSource}" d="M${back-1} ${v.top+7} Q160 ${v.top+9} ${front+1} ${v.top+7}" fill="none"/>`;
      }else if((this.data.kind==='tops'||this.data.kind==='dress')&&d.chest){
        const {width:w,bottom,hemRatio}=this.topDrawingGeometry(row,shape,'side'),back=160-w*.72,front=160+w*.82;
        const s=this.sleeveDrawing(row,shape,'side'),end=s.end,armX=151+(end-95)*.20,inset=(front-back)*(1-hemRatio)/2;
        const hemBack=this.data.kind==='tops'?back+inset:back-2,hemFront=this.data.kind==='tops'?front-inset:front+1;
        garment=`<path data-part="profile-top" data-hem-source="schematic" data-hem-ratio="${hemRatio}" d="M147 78 Q155 85 163 79 Q${front} 92 ${front} 126 L${hemFront} ${bottom} L${hemBack} ${bottom} L${back} 123 Q${back} 90 147 78 Z"/><path d="M${hemBack+1} ${bottom-7} L${hemFront-1} ${bottom-7}" fill="none" opacity=".55"/>`;
        const sleeveBack=this.visualFitNeeded(row)?Math.min(144,149-armWidth-1.2):144,sleeveFront=this.visualFitNeeded(row)?Math.max(165,156+armWidth+1.2):165;
        const sleeveMeta=s.source==='garment'?'':` data-sleeve-source="${s.source}" data-sleeve-style="${s.style}"`;
        sleeve=s.style==='none'?'':`<path data-part="profile-sleeve"${sleeveMeta} d="M147 94 Q158 89 ${sleeveFront} 102 L${armX+10} ${end} L${armX-9} ${end+4} L${sleeveBack} 118 Q140 104 147 94 Z"/><path d="M${armX-9} ${end-2} L${armX+9} ${end-5}" fill="none" opacity=".55"/>`;
        if(s.arm)sleeve=this.fittedSleeve(shape,s,'side');
      }
      return `<g data-part="mannequin" fill="#fcfcfd" stroke="#d7d8de" stroke-width=".9">${leg(155,true)}${leg(164,false)}${torso}${head}</g><g data-part="garment" fill="#e9eaed" opacity=".78" stroke="#303640" stroke-width="1.35">${garment}</g><g fill="#fcfcfd" stroke="#d7d8de" stroke-width=".9">${arm}</g><g fill="#e9eaed" opacity=".78" stroke="#303640" stroke-width="1.35">${sleeve}</g>`;
    }
    calloutData(row,shape){
      const bottom=this.data.kind==='bottoms'||this.data.kind==='skirt',items=[];
      for(const key of bottom?['waist','hip']:['shoulder','chest']){
        const m=row.metrics[key];if(m&&m.ease>=0)items.push({key,type:'ease',min:m.ease,max:m.maxEase,label:m.label,basis:key==='shoulder'?'width':'circumference'});
      }
      if(!bottom&&row.dims.sleeve)items.push({key:'sleeve',type:'measurement',...row.dims.sleeve});
      const key=bottom?(row.dims.outseam?'outseam':row.dims.inseam?'inseam':null):row.dims.length?'length':null;
      if(key){
        const m=row.dims[key],reference=bottom?(shape.y.ankle-(key==='outseam'?shape.y.waist:shape.y.crotch))/shape.scale:(shape.y.crotch-85)/shape.scale;
        items.push({key,type:'length',min:m.min,max:m.max,offsetMin:round(m.min-reference),offsetMax:round(m.max-reference),reference:bottom?'ankle':'crotch'});
      }
      return items;
    }
    diagramBounds(shape){
      const bottom=this.data.kind==='bottoms'||this.data.kind==='skirt';let halfSpan=shape.front.shoulder+155,height=420;
      for(const row of this.result.rows.filter(r=>this.canDiagram(r))){
        if(bottom){const g=this.pantsDrawingGeometry(row,shape);halfSpan=Math.max(halfSpan,g.front.waist+152,g.front.hip+152);}
        else{const g=this.topDrawingGeometry(row,shape,'front');halfSpan=Math.max(halfSpan,g.width+152,g.shoulder+152);if(row.dims.length)height=Math.max(height,g.bottom+92);}
      }
      halfSpan=Math.ceil(halfSpan);return {left:160-halfSpan,right:160+halfSpan,width:halfSpan*2,height:Math.ceil(height)};
    }
    calloutBox(item,x,y,width,lines){
      const measure=line=>[...line].reduce((n,c)=>n+(/\p{Mark}/u.test(c)?0:/[\u0e00-\u0e7f]/u.test(c)?.55:c.codePointAt(0)>0x2e7f?1:.57),0);
      let extraLines=Math.max(0,4-lines.length);
      const rows=lines.flatMap((line,i)=>{
        const limit=(width-16)/10.5,words=line.split(' ');let parts=[line],best=Infinity;
        if(measure(line)>limit&&extraLines>0)for(let cut=1;cut<words.length;cut++){
          const candidate=[words.slice(0,cut).join(' '),words.slice(cut).join(' ')],score=Math.max(...candidate.map(measure));
          if(score<best){best=score;parts=candidate;}
        }
        const split=parts.length===2&&extraLines>0;if(split)extraLines--;
        return (split?parts:[line]).map(text=>({text,preferred:i===1?15:i===0?13:12,weight:i===1?600:500}));
      });
      const height=rows.length<=2?44:rows.length*18+6;
      const text=rows.map((row,i)=>{
        const natural=Math.min(row.preferred,(width-16)/Math.max(1,measure(row.text))),font=Math.max(9.5,natural),fit=natural<9.5?` textLength="${width-16}" lengthAdjust="spacingAndGlyphs"`:'';
        return `<text x="${x+width/2}" y="${y+16+i*18}" text-anchor="middle" font-size="${font}" font-weight="${row.weight}" fill="#424752"${fit}>${esc(row.text)}</text>`;
      }).join('');
      return `<g data-fit-callout="${item.key}" data-value-kind="${item.type}" data-value-min="${item.min}" data-value-max="${item.max}"${item.basis?` data-value-basis="${item.basis}"`:''}${item.reference?` data-position-reference="${item.reference}" data-offset-min="${item.offsetMin}" data-offset-max="${item.offsetMax}"`:''} font-family="Arial, 'Hiragino Sans', sans-serif"><rect x="${x}" y="${y}" width="${width}" height="${height}" rx="8" fill="#fff" stroke="#d7d9df" stroke-width=".9"/>${text}</g>`;
    }
    diagramCallouts(row,shape,bounds){
      const side=this.view==='side',bottom=this.data.kind==='bottoms'||this.data.kind==='skirt',items=this.calloutData(row,shape),g=bottom?this.pantsDrawingGeometry(row,shape):this.topDrawingGeometry(row,shape,this.view);
      const id=esc((this.uid||'nsa-fit')+'-'+this.view+'-arrow'),left=bounds.left+8,right=bounds.right-140;
      const signedRange=(min,max)=>this.signed(min)+(min!==max?'–'+this.signed(max):'');
      const arrow=(key,x1,y1,x2,y2)=>`<path data-fit-arrow="${key}" d="M${x1} ${y1} L${x2} ${y2}" fill="none" marker-start="url(#${id})" marker-end="url(#${id})"/>`;
      const leader=(key,x1,y1,x2,y2)=>`<path data-fit-leader="${key}" d="M${x1} ${y1} L${x2} ${y2}" fill="none" stroke-dasharray="2 2" stroke-width=".8"/><circle cx="${x2}" cy="${y2}" r="2.2" fill="#646975" stroke="none"/>`;
      let guides='',labels='';
      for(const item of items){
        if(item.type==='ease'){
          if(side&&item.key==='shoulder')continue;
          let x1,x2,y,boxY;
          if(bottom){const f=g[this.view],r=f[item.key];x1=160-r*(side?(item.key==='waist'?.75:.95):1);x2=160+r*(side?(item.key==='waist'?.82:.85):1);y=item.key==='waist'?g.y.top+4:g.y.hip;boxY=item.key==='waist'?120:204;}
          else{const r=item.key==='shoulder'?g.shoulder:g.width;x1=160-r*(side?.72:1);x2=160+r*(side?.82:1);y=item.key==='shoulder'?88:125;boxY=item.key==='shoulder'?43:128;}
          guides+=arrow(item.key,x1,y,x2,y)+leader(item.key,left+132,boxY+30,x1,y);
          labels+=this.calloutBox(item,left,boxY,132,[this.t(item.key)+' · '+this.t('callout_ease'),this.t('callout_approx')+' '+signedRange(item.min,item.max)+' cm',this.t(item.label)]);
        }else if(item.key==='sleeve'){
          const s=this.sleeveDrawing(row,shape,this.view);let start,end;
          if(side){start=[176,98];end=[151+(s.end-95)*.20+15,s.end];}
          else{const a=this.armDrawingGeometry(shape,'front'),angle=-70*Math.PI/180,dx=a.width+15;const point=y=>[160+shape.front.shoulder+dx*Math.cos(angle)-(y-89)*Math.sin(angle),89+dx*Math.sin(angle)+(y-89)*Math.cos(angle)];start=point(93);end=point(s.end);}
          guides+=arrow(item.key,...start,...end)+leader(item.key,right+66,79,...end);
          labels+=this.calloutBox(item,right,35,132,[this.t('sleeve'),this.dim(item)+' cm']);
        }else{
          const boxX=bottom?right:67,boxY=bottom?Math.max(280,g.y.bottom-50):g.bottom+14,width=bottom?132:186;
          const labelKey=this.data.kind==='skirt'?'length':item.key,from=this.t('callout_from_'+item.reference),above=this.t('callout_above'),below=this.t('callout_below'),approx=this.t('callout_approx');
          const offset=item.offsetMax<=0&&item.offsetMin<0?above+' '+approx+' '+this.dim({min:-item.offsetMax,max:-item.offsetMin})+' cm':item.offsetMin>=0?below+' '+approx+' '+this.dim({min:item.offsetMin,max:item.offsetMax})+' cm':above+' '+(-item.offsetMin)+' cm – '+below+' '+item.offsetMax+' cm';
          if(bottom){const f=g[this.view],x=side?160+f.hip*.85+9:160+Math.max(f.hip,f.stance+f.hem)+9;guides+=arrow(item.key,x,item.key==='inseam'?shape.y.crotch:g.y.top,x,g.y.bottom)+leader(item.key,boxX,boxY+22,x,g.y.bottom);}
          else{guides+=arrow(item.key,160,85,160,g.bottom)+leader(item.key,160,boxY,160,g.bottom);}
          labels+=this.calloutBox(item,boxX,boxY,width,[this.t(labelKey)+' '+this.dim(item)+' cm',from+' '+offset]);
        }
      }
      return `<defs><marker id="${id}" viewBox="0 0 10 10" refX="5" refY="5" markerWidth="5" markerHeight="5" orient="auto-start-reverse"><path d="M0 0 L10 5 L0 10 Z" fill="#646975"/></marker></defs><g data-part="fit-guides" stroke="#646975" stroke-width="1.15" stroke-linecap="round" stroke-linejoin="round">${guides}</g><g data-part="fit-callouts">${labels}</g>`;
    }
    diagramFrame(shapes,shape,row){
      const bounds=this.diagramBounds(shape);
      return `<svg viewBox="${bounds.left} 0 ${bounds.width} ${bounds.height}" data-illustration-style="outline" data-illustration-pose="${this.view==='front'?'open-arms':'profile'}" data-illustration-view="${this.view}" data-body-inseam-ratio="${shape.inseamRatio}" role="img" aria-label="${this.text('diagram')} ${this.text(this.view)} ${esc(this.selected)}"><g data-part="barefoot-figure"><text x="160" y="11" text-anchor="middle" fill="#72757e" font-size="10">${esc(this.profile.height)} cm</text><g stroke-linecap="round" stroke-linejoin="round">${shapes}</g></g>${this.diagramCallouts(row,shape,bounds)}</svg>`;
    }
  }
  customElements.define('nano-size-advisor',NanoSizeAdvisor);
})();
  } catch(e) { console.error(e); }
})();

})();
